
const $6ed61c8640a9c1ac$var$BALL_WIDTH = 25;
class $6ed61c8640a9c1ac$export$6dddbaab7b8f4743 {
    constructor(){
        this.posX = 0;
        this.velocityX = 90;
        this.time = 0;
        this.bounceHeight = 50;
        this.bounceFrequency = 1.2;
        this.radius = $6ed61c8640a9c1ac$var$BALL_WIDTH / 2;
        this.rotation = 0;
        this.rotationRate = 0.18;
        this.animateBall = (timeStamp)=>{
            if (!this.lastTime) this.lastTime = timeStamp;
            const dt = (timeStamp - this.lastTime) / 1000;
            this.lastTime = timeStamp;
            this.time += dt;
            this.posX += this.velocityX * dt;
            const maxX = this.box.clientWidth - $6ed61c8640a9c1ac$var$BALL_WIDTH;
            if (this.posX <= 0) {
                this.posX = 0;
                this.velocityX = Math.abs(this.velocityX);
            } else if (this.posX >= maxX) {
                this.posX = maxX;
                this.velocityX = -Math.abs(this.velocityX);
            }
            const phase = this.time * Math.PI * this.bounceFrequency;
            const y = Math.abs(Math.sin(phase)) * this.bounceHeight;
            const degPerPx = 360 / (2 * Math.PI * this.radius);
            this.rotation += this.velocityX * dt * degPerPx * this.rotationRate;
            this.ball.style.transform = `translate(${this.posX}px, -${y}px) rotate(${this.rotation}deg)`;
            requestAnimationFrame(this.animateBall);
        };
        this.box = document.querySelector("[data-basketball]");
        this.ball = this.box.children[0];
        this.init();
    }
    init() {
        requestAnimationFrame(this.animateBall);
    }
}


const $9e7e0b5c3563d8d6$export$7d15b64cf5a3a4c4 = (num, min, max)=>{
    return Math.min(Math.max(num, min), max);
};


const $570588f05c4206f4$export$1157fb72e7fbceb5 = (x)=>{
    return 1 - Math.pow(1 - x, 3);
};
const $570588f05c4206f4$export$894fdbb88fdb9ced = (x)=>{
    return Math.sin(x * Math.PI / 2);
};


const $cdb99edfce3a690f$export$3a89f8d6f6bf6c9f = (start, end, t)=>{
    return start + (end - start) * t;
};


const $33b2d2d40c177c1d$export$d0a8044dce8ff2fc = ()=>{
    return /Mobi|Android|iPhone/i.test(navigator.userAgent) || /Safari/i.test(navigator.userAgent) && navigator.maxTouchPoints > 0;
};


const $07d93c758297752a$export$b1a1fb9a3c566543 = (num)=>{
    return num % 1 === 0 ? num.toFixed(1) : num.toString();
};


const $2a8d297402734a47$export$c435da95ea8cb26 = ({ width: width, columnOneHeight: columnOneHeight, columnTwoHeight: columnTwoHeight, gap: gap, gapInset: gapInset, radius: radius })=>{
    return `
    M 0 ${radius}
    a ${radius} ${radius} 0 0 1 ${radius} -${radius}
    h ${width - 2 * radius}
    a ${radius} ${radius} 0 0 1 ${radius} ${radius}
    v ${columnOneHeight - 2 * radius}
    a ${radius} ${radius} 0 0 1 -${radius} ${radius}
    h -${gapInset - radius}
    a ${radius} ${radius} 0 0 0 -${radius} ${radius}
    v ${gap - 2 * radius}
    a ${radius} ${radius} 0 0 0 ${radius} ${radius}
    h ${gapInset - radius}
    a ${radius} ${radius} 0 0 1 ${radius} ${radius}
    v ${columnTwoHeight - 2 * radius}
    a ${radius} ${radius} 0 0 1 -${radius} ${radius}
    h -${width - 2 * radius}
    a ${radius} ${radius} 0 0 1 -${radius} -${radius}
    v -${columnTwoHeight - 2 * radius}
    a ${radius} ${radius} 0 0 1 ${radius} -${radius}
    h ${gapInset - radius}
    a ${radius} ${radius} 0 0 0 ${radius} -${radius}
    v -${gap - 2 * radius}
    a ${radius} ${radius} 0 0 0 -${radius} -${radius}
    h -${gapInset - radius}
    a ${radius} ${radius} 0 0 1 -${radius} -${radius}
    Z
  `.replace(/\s+/g, " ").trim();
};
const $2a8d297402734a47$export$4064ccfd0479f329 = ({ height: height, columnOneWidth: columnOneWidth, columnTwoWidth: columnTwoWidth, gap: gap, gapInset: gapInset, radius: radius })=>{
    return `
    M 0 ${radius}
    a ${radius} ${radius} 0 0 1 ${radius} -${radius}
    h ${columnOneWidth - 2 * radius}
    a ${radius} ${radius} 0 0 1 ${radius} ${radius}
    v ${gapInset - 2 * radius}
    a ${radius} ${radius} 0 0 0 ${radius} ${radius}
    h ${gap - 2 * radius}
    a ${radius} ${radius} 0 0 0 ${radius} -${radius}
    v -${gapInset - 2 * radius}
    a ${radius} ${radius} 0 0 1 ${radius} -${radius}
    h ${columnTwoWidth - 2 * radius}
    a ${radius} ${radius} 0 0 1 ${radius} ${radius}
    v ${height - 2 * radius}
    a ${radius} ${radius} 0 0 1 -${radius} ${radius}
    h -${columnTwoWidth - 2 * radius}
    a ${radius} ${radius} 0 0 1 -${radius} -${radius}
    v -${gapInset - 2 * radius}
    a ${radius} ${radius} 0 0 0 -${radius} -${radius}
    h -${gap - 2 * radius}
    a ${radius} ${radius} 0 0 0 -${radius} ${radius}
    v ${gapInset - 2 * radius}
    a ${radius} ${radius} 0 0 1 -${radius} ${radius}
    h -${columnOneWidth - 2 * radius}
    a ${radius} ${radius} 0 0 1 -${radius} -${radius}
    Z
  `.replace(/\s+/g, " ").trim();
};


/**
 * Testing flag: append `?mobilevideoload=true` to the URL to preload every
 * lineup background video on page load and skip the mobile swap/play delays.
 */ const $e11d3b47fe7a2d7b$export$4eb74929f54da8ee = ()=>{
    try {
        return new URLSearchParams(window.location.search).get("mobilevideoload") === "true";
    } catch  {
        return false;
    }
};




class $5ce8c6471a69ea3e$export$10f66a48975af9bf {
    constructor(contestTimestamps){
        this.forceAnimateCountdown = false;
        this.onNavPointerDown = (e)=>{
            if (e.pointerType !== "touch") return;
            e.preventDefault();
            const startX = e.clientX;
            const tabControlListX = this.tabControlList.getBoundingClientRect().x;
            const { x: activeTabControlX, width: activeTabControlWidth } = this.activeTabControlListItem.getBoundingClientRect();
            const startTranslateX = -activeTabControlX - activeTabControlWidth / 2 + document.body.clientWidth / 2 + tabControlListX;
            const startActiveIndex = this.activeTabIndex;
            this.tabControlList.style.setProperty("transition", "none");
            this.tabControlHighlightList.style.setProperty("transition", "none");
            const onWindowPointerMove = (e)=>{
                const deltaX = e.clientX - startX;
                const translateX = startTranslateX + deltaX;
                this.tabControlList.style.setProperty("transform", `translateX(${translateX}px)`);
                this.tabControlHighlightList.style.setProperty("transform", `translateX(${translateX}px)`);
                const nextActiveIndex = Math.round(startActiveIndex - deltaX / activeTabControlWidth);
                const index = (0, $9e7e0b5c3563d8d6$export$7d15b64cf5a3a4c4)(nextActiveIndex, 0, this.tabControlListItems.length - 1);
                this.onTabClick(index, false, true);
            };
            const onWindowPointerUp = (e)=>{
                const deltaX = e.clientX - startX;
                const nextActiveIndex = startActiveIndex - Math.round(deltaX / activeTabControlWidth);
                const index = (0, $9e7e0b5c3563d8d6$export$7d15b64cf5a3a4c4)(nextActiveIndex, 0, this.tabControlListItems.length - 1);
                this.tabControlList.style.removeProperty("transition");
                this.tabControlHighlightList.style.removeProperty("transition");
                this.onTabClick(index, true);
                window.removeEventListener("pointermove", onWindowPointerMove);
                window.removeEventListener("pointerup", onWindowPointerUp);
            };
            window.addEventListener("pointermove", onWindowPointerMove);
            window.addEventListener("pointerup", onWindowPointerUp);
        };
        this.updateTabControlListPosition = ()=>{
            const tabControlListX = this.tabControlList.getBoundingClientRect().x;
            const { x: activeTabControlX, width: activeTabControlWidth } = this.activeTabControlListItem.getBoundingClientRect();
            const translateX = -activeTabControlX - activeTabControlWidth / 2 + document.body.clientWidth / 2 + tabControlListX;
            this.tabControlList.style.setProperty("transform", `translateX(${translateX}px)`);
            this.tabControlHighlightList.style.setProperty("transform", `translateX(${translateX}px)`);
        };
        this.onTabClick = (tabIndex, forceUpdate, isDragging)=>{
            if (!forceUpdate && tabIndex === this.activeTabIndex) return;
            if (tabIndex !== this.activeTabIndex) this.forceAnimateCountdown = true;
            this.activeTabIndex = tabIndex;
            this.activeTabControlListItem.classList.remove("homepage-contest-nav__item--active");
            this.activeTabBodyItem.classList.remove("homepage-contest-details--active");
            this.activeTabBodyItem.setAttribute("aria-hidden", "true");
            const newActiveTabControlListItem = this.tabControlListItems[tabIndex];
            const newActiveTabBodyItem = this.tabBodyItems[tabIndex];
            newActiveTabControlListItem.classList.add("homepage-contest-nav__item--active");
            newActiveTabBodyItem.classList.add("homepage-contest-details--active");
            newActiveTabBodyItem.setAttribute("aria-hidden", "false");
            this.activeTabControlListItem = newActiveTabControlListItem;
            this.activeTabBodyItem = newActiveTabBodyItem;
            if (!isDragging) this.updateTabControlListPosition();
        };
        this.initializeCountdown = ()=>{
            if (!this.countdown) return;
            const daysEl = this.countdown.querySelector("#countdown-days");
            const hoursEl = this.countdown.querySelector("#countdown-hours");
            const minutesEl = this.countdown.querySelector("#countdown-minutes");
            const secondsEl = this.countdown.querySelector("#countdown-seconds");
            if (!daysEl || !hoursEl || !minutesEl || !secondsEl) return;
            const updateCountdown = ()=>{
                const now = Date.now();
                const targetDateMilliseconds = this.contestTimestamps[this.activeTabIndex] * 1000;
                const diff = targetDateMilliseconds - now;
                if (!daysEl.innerHTML) {
                    daysEl.innerHTML = `<span aria-hidden="true">00</span><span>00</span>`;
                    hoursEl.innerHTML = `<span aria-hidden="true">00</span><span>00</span>`;
                    minutesEl.innerHTML = `<span aria-hidden="true">00</span><span>00</span>`;
                    secondsEl.innerHTML = `<span aria-hidden="true">00</span><span>00</span>`;
                    requestAnimationFrame(updateCountdown);
                    return;
                }
                const isPast = diff < 0;
                const isPrevPast = daysEl.children[1].classList.contains("homepage-contest-countdown-digits-past");
                this.countdown.classList.toggle("homepage-contest-countdown--past", isPast);
                const days = Math.floor(diff / 86400000);
                const hours = Math.floor(diff % 86400000 / 3600000);
                const minutes = Math.floor(diff % 3600000 / 60000);
                const seconds = Math.floor(diff % 60000 / 1000);
                const nextDays = String(Math.max(days, 0)).padStart(2, "0");
                const nextHours = String(Math.max(hours, 0)).padStart(2, "0");
                const nextMinutes = String(Math.max(minutes, 0)).padStart(2, "0");
                const nextSeconds = String(Math.max(seconds, 0)).padStart(2, "0");
                const forceUpdate = isPast !== isPrevPast || this.forceAnimateCountdown && !isPast;
                if (daysEl.children[1].textContent !== nextDays || forceUpdate) {
                    daysEl.classList.add("homepage-contest-countdown-digits--updating");
                    daysEl.children[0].innerHTML = daysEl.children[1].innerHTML;
                    daysEl.children[0].classList.toggle("homepage-contest-countdown-digits-past", isPrevPast);
                    daysEl.children[1].innerHTML = nextDays;
                    daysEl.children[1].classList.toggle("homepage-contest-countdown-digits-past", isPast);
                    const valueEl = daysEl.parentElement;
                    valueEl.classList.toggle("homepage-contest-countdown-value--three-digits", nextDays.length === 3);
                } else daysEl.classList.remove("homepage-contest-countdown-digits--updating");
                if (hoursEl.children[1].textContent !== nextHours || forceUpdate) {
                    hoursEl.classList.add("homepage-contest-countdown-digits--updating");
                    hoursEl.children[0].innerHTML = hoursEl.children[1].innerHTML;
                    hoursEl.children[0].classList.toggle("homepage-contest-countdown-digits-past", isPrevPast);
                    hoursEl.children[1].innerHTML = nextHours;
                    hoursEl.children[1].classList.toggle("homepage-contest-countdown-digits-past", isPast);
                } else hoursEl.classList.remove("homepage-contest-countdown-digits--updating");
                if (minutesEl.children[1].textContent !== nextMinutes || forceUpdate) {
                    minutesEl.classList.add("homepage-contest-countdown-digits--updating");
                    minutesEl.children[0].innerHTML = minutesEl.children[1].innerHTML;
                    minutesEl.children[0].classList.toggle("homepage-contest-countdown-digits-past", isPrevPast);
                    minutesEl.children[1].innerHTML = nextMinutes;
                    minutesEl.children[1].classList.toggle("homepage-contest-countdown-digits-past", isPast);
                } else minutesEl.classList.remove("homepage-contest-countdown-digits--updating");
                if (secondsEl.children[1].textContent !== nextSeconds || forceUpdate) {
                    // secondsEl.classList.add("homepage-contest-countdown-digits--updating");
                    if (forceUpdate) secondsEl.classList.add("homepage-contest-countdown-digits--updating");
                    secondsEl.children[0].innerHTML = secondsEl.children[1].innerHTML;
                    secondsEl.children[0].classList.toggle("homepage-contest-countdown-digits-past", isPrevPast);
                    secondsEl.children[1].innerHTML = nextSeconds;
                    secondsEl.children[1].classList.toggle("homepage-contest-countdown-digits-past", isPast);
                } else secondsEl.classList.remove("homepage-contest-countdown-digits--updating");
                if (this.forceAnimateCountdown) this.forceAnimateCountdown = false;
                requestAnimationFrame(updateCountdown);
            };
            requestAnimationFrame(updateCountdown);
        };
        this.onBodyResize = ()=>{
            this.tabControlList.style.setProperty("transition", "none");
            this.tabControlHighlightList.style.setProperty("transition", "none");
            this.updateTabControlListPosition();
            requestAnimationFrame(()=>{
                this.tabControlList.style.removeProperty("transition");
                this.tabControlHighlightList.style.removeProperty("transition");
            });
        };
        this.contestTimestamps = contestTimestamps;
        this.tabControlList = document.querySelector("[data-contest-tab-control-list]");
        const tabControlHighlight = document.querySelector("[data-contest-tab-control-highlight]");
        this.tabControlHighlightList = this.tabControlList.cloneNode(true);
        this.tabControlHighlightList.querySelectorAll("li").forEach((li)=>{
            li.classList.remove("homepage-contest-nav__item--past");
            li.classList.remove("homepage-contest-nav__item--active");
        });
        tabControlHighlight.appendChild(this.tabControlHighlightList);
        this.tabControlListItems = Array.from(this.tabControlList.querySelectorAll("li"));
        this.activeTabControlListItem = this.tabControlList.querySelector(".homepage-contest-nav__item--active");
        this.activeTabIndex = Array.from(this.tabControlListItems).indexOf(this.activeTabControlListItem);
        this.tabBody = document.querySelector("#contest-tab-body");
        this.tabBodyItems = Array.from(this.tabBody.querySelectorAll(".homepage-contest-details"));
        this.activeTabBodyItem = this.tabBody.querySelector(".homepage-contest-details--active");
        this.countdown = document.querySelector("#homepage-contest-countdown");
        this.bodyResizeObserver = new ResizeObserver(this.onBodyResize);
        this.bodyResizeObserver.observe(document.body);
        this.init();
    }
    init() {
        this.updateTabControlListPosition();
        this.tabControlListItems.forEach((item, index)=>{
            const tabButton = item.querySelector("button");
            tabButton.addEventListener("click", ()=>this.onTabClick(index));
        });
        this.tabBodyItems.forEach((item, index)=>{
            item.setAttribute("aria-hidden", index !== this.activeTabIndex ? "true" : "false");
        });
        this.initializeCountdown();
        if ((0, $33b2d2d40c177c1d$export$d0a8044dce8ff2fc)()) {
            const parent = this.tabControlList.parentElement;
            parent.style.setProperty("touch-action", "none");
            this.tabControlList.parentElement?.addEventListener("pointerdown", this.onNavPointerDown);
        }
    }
}


const $0736497199cfcb1e$var$DESKTOP_CROSSHAIR_INDICES = [
    [
        0,
        1,
        3,
        4
    ],
    [
        1,
        2,
        4,
        5
    ],
    [
        3,
        4,
        6,
        7
    ],
    [
        4,
        5,
        7,
        8
    ],
    [
        6,
        7,
        9,
        10
    ],
    [
        7,
        8,
        10,
        11
    ]
];
const $0736497199cfcb1e$var$MOBILE_CROSSHAIR_INDICES = [
    [
        0,
        1,
        2,
        3
    ],
    [
        2,
        3,
        4,
        5
    ],
    [
        4,
        5,
        6,
        7
    ],
    [
        6,
        7,
        8,
        9
    ],
    [
        8,
        9,
        10,
        11
    ],
    [
        10,
        11,
        12,
        13
    ]
];
class $0736497199cfcb1e$export$7f3c5e03dd3ddc68 {
    constructor({ lenis: lenis }){
        this.isPristine = true;
        this.prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        this.onInputFocus = (index)=>{
            if (index <= $0736497199cfcb1e$var$DESKTOP_CROSSHAIR_INDICES.length - 1) this.focusedInputIndex = index;
            if (this.isPristine) {
                this.isPristine = false;
                this.showLegalRow();
            }
            if (this.prefersReducedMotion) return;
            this.setActiveInputCrosshairs(index);
        };
        this.onInputBlur = ()=>{
            this.focusedInputIndex = undefined;
            this.resetInputCrosshairs();
        };
        this.onInputMouseOver = (index)=>{
            if (this.focusedInputIndex !== undefined) return;
            this.setActiveInputCrosshairs(index);
        };
        this.onInputMouseOut = ()=>{
            if (this.focusedInputIndex !== undefined) return;
            this.resetInputCrosshairs();
        };
        this.onFormInput = ()=>{
            const isValid = this.form.checkValidity();
            this.submitButton.toggleAttribute("disabled", !isValid);
        };
        this.onFormSubmit = (event)=>{
            event.preventDefault();
            const formData = new FormData(this.form);
            const data = Object.fromEntries(formData.entries());
            this.errorResponseElement.classList.remove("homepage-contest-form-error-response--active");
            fetch(`${location.origin}/wp-content/themes/nba-represent/_inc/nba-submit-form.php`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(data)
            }).then((res)=>{
                if (!res.ok) throw new Error(`HTTP error! Status: ${res.status}`);
                return res.json();
            }).then((responseData)=>this.handleFormResponse(responseData)).catch((err)=>console.error("Fetch error:", err));
        };
        this.onFormError = (message)=>{
            this.errorResponseElement.classList.add("homepage-contest-form-error-response--active");
            this.errorResponseElement.innerHTML = message;
            if (this.lenis) this.lenis.scrollTo(this.errorResponseElement, {
                offset: -window.innerHeight / 2,
                immediate: this.prefersReducedMotion
            });
            else this.errorResponseElement.scrollIntoView({
                behavior: this.prefersReducedMotion ? "auto" : "smooth",
                block: "center"
            });
        };
        this.onFormSuccess = (message)=>{
            this.form.remove();
            this.successResponseElement.classList.add("homepage-contest-form-success-response--active");
            this.successResponseMessageElement.innerHTML = message;
            if (this.lenis) this.lenis.scrollTo(this.successResponseElement, {
                offset: -window.innerHeight / 2,
                immediate: this.prefersReducedMotion
            });
            else this.successResponseElement.scrollIntoView({
                behavior: this.prefersReducedMotion ? "auto" : "smooth",
                block: "center"
            });
        };
        this.resetInputCrosshairs = ()=>{
            this.desktopCrosshairSVGs.forEach((svg)=>{
                svg.children[0].setAttribute("style", "transform: translate(0px, 0px)");
                svg.children[1].setAttribute("style", "transform: translate(0px, 0px)");
            });
            this.mobileCrosshairSVGs.forEach((svg)=>{
                svg.children[0].setAttribute("style", "transform: translate(0px, 0px)");
                svg.children[1].setAttribute("style", "transform: translate(0px, 0px)");
            });
        };
        this.lenis = lenis;
        this.form = document.querySelector("#contest-form");
        this.inputElements = Array.from(this.form.querySelectorAll(".homepage-contest-form__row input, .homepage-contest-form__row select"));
        this.legalRow = document.querySelector("#contest-form-legal-row");
        this.submitButton = document.querySelector("#contest-form-submit");
        this.errorResponseElement = document.querySelector("#contest-form-error-response");
        this.successResponseElement = document.querySelector("#contest-form-success-response");
        this.successResponseMessageElement = document.querySelector(".homepage-contest-form-success-response__content");
        this.desktopCrosshairSVGs = Array.from(this.form.querySelectorAll(".homepage-section-border--desktop svg"));
        this.mobileCrosshairSVGs = Array.from(this.form.querySelectorAll(".homepage-section-border--mobile svg"));
        this.init();
    }
    init() {
        this.form.addEventListener("input", this.onFormInput);
        this.form.addEventListener("submit", this.onFormSubmit);
        this.inputElements.forEach((input, index)=>{
            input.addEventListener("focus", ()=>this.onInputFocus(index));
            if (!this.prefersReducedMotion) {
                input.addEventListener("blur", this.onInputBlur);
                input.addEventListener("mouseover", ()=>this.onInputMouseOver(index));
                input.addEventListener("mouseout", this.onInputMouseOut);
            }
        });
    }
    handleFormResponse(data) {
        console.log("Fetched data:", data);
        if (data.success) this.onFormSuccess(data.message);
        else this.onFormError(data.message);
    }
    setActiveInputCrosshairs(index) {
        if (index > $0736497199cfcb1e$var$DESKTOP_CROSSHAIR_INDICES.length - 1) {
            this.resetInputCrosshairs();
            return;
        }
        const desktopTopLeftIndex = $0736497199cfcb1e$var$DESKTOP_CROSSHAIR_INDICES[index][0];
        const desktopTopRightIndex = $0736497199cfcb1e$var$DESKTOP_CROSSHAIR_INDICES[index][1];
        const desktopBottomLeftIndex = $0736497199cfcb1e$var$DESKTOP_CROSSHAIR_INDICES[index][2];
        const desktopBottomRightIndex = $0736497199cfcb1e$var$DESKTOP_CROSSHAIR_INDICES[index][3];
        const mobileTopLeftIndex = $0736497199cfcb1e$var$MOBILE_CROSSHAIR_INDICES[index][0];
        const mobileTopRightIndex = $0736497199cfcb1e$var$MOBILE_CROSSHAIR_INDICES[index][1];
        const mobileBottomLeftIndex = $0736497199cfcb1e$var$MOBILE_CROSSHAIR_INDICES[index][2];
        const mobileBottomRightIndex = $0736497199cfcb1e$var$MOBILE_CROSSHAIR_INDICES[index][3];
        this.desktopCrosshairSVGs.forEach((svg, i)=>{
            switch(i){
                case desktopTopLeftIndex:
                    svg.children[0].setAttribute("style", "transform: translate(-5px, 0px)");
                    svg.children[1].setAttribute("style", "transform: translate(0px, -5px)");
                    break;
                case desktopTopRightIndex:
                    svg.children[0].setAttribute("style", "transform: translate(5px, 0px)");
                    svg.children[1].setAttribute("style", "transform: translate(0px, -5px)");
                    break;
                case desktopBottomLeftIndex:
                    svg.children[0].setAttribute("style", "transform: translate(-5px, 0px)");
                    svg.children[1].setAttribute("style", "transform: translate(0px, 5px)");
                    break;
                case desktopBottomRightIndex:
                    svg.children[0].setAttribute("style", "transform: translate(5px, 0px)");
                    svg.children[1].setAttribute("style", "transform: translate(0px, 5px)");
                    break;
                default:
                    svg.children[0].setAttribute("style", "transform: translate(0px, 0px)");
                    svg.children[1].setAttribute("style", "transform: translate(0px, 0px)");
                    break;
            }
        });
        this.mobileCrosshairSVGs.forEach((svg, i)=>{
            switch(i){
                case mobileTopLeftIndex:
                    svg.children[0].setAttribute("style", "transform: translate(-5px, 0px)");
                    svg.children[1].setAttribute("style", "transform: translate(0px, -5px)");
                    break;
                case mobileTopRightIndex:
                    svg.children[0].setAttribute("style", "transform: translate(5px, 0px)");
                    svg.children[1].setAttribute("style", "transform: translate(0px, -5px)");
                    break;
                case mobileBottomLeftIndex:
                    svg.children[0].setAttribute("style", "transform: translate(-5px, 0px)");
                    svg.children[1].setAttribute("style", "transform: translate(0px, 5px)");
                    break;
                case mobileBottomRightIndex:
                    svg.children[0].setAttribute("style", "transform: translate(5px, 0px)");
                    svg.children[1].setAttribute("style", "transform: translate(0px, 5px)");
                    break;
                default:
                    svg.children[0].setAttribute("style", "transform: translate(0px, 0px)");
                    svg.children[1].setAttribute("style", "transform: translate(0px, 0px)");
                    break;
            }
        });
    }
    showLegalRow() {
        this.legalRow.classList.add("homepage-contest-form__legal-row--active");
        this.legalRow.style.setProperty("max-height", `${this.legalRow.scrollHeight}px`);
        this.legalRow.addEventListener("transitionend", ()=>{
            this.legalRow.style.setProperty("max-height", "10000px");
        }, {
            once: true
        });
    }
}



class $a665cea990d6196d$export$cc6082f938514827 {
    constructor(contestTimestamp){
        this.updateCountdown = ()=>{
            const now = Date.now();
            const targetDateMilliseconds = this.contestTimestamp * 1000;
            const diff = targetDateMilliseconds - now;
            if (diff < 0) {
                this.countdown.innerHTML = `00:00:00:00`;
                return;
            }
            const days = Math.floor(diff / 86400000);
            const hours = Math.floor(diff % 86400000 / 3600000);
            const minutes = Math.floor(diff % 3600000 / 60000);
            const seconds = Math.floor(diff % 60000 / 1000);
            this.countdown.innerHTML = `${String(days).padStart(2, "0")}:${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
            requestAnimationFrame(this.updateCountdown);
        };
        this.setTicketClipPath = ()=>{
            const { width: ticketWidth, height: ticketHeight } = this.container.getBoundingClientRect();
            const { width: columnOneWidth, height: columnOneHeight } = this.container.querySelectorAll("[data-ticket-column]")[0].getBoundingClientRect();
            const { width: columnTwoWidth, height: columnTwoHeight } = this.container.querySelectorAll("[data-ticket-column]")[1].getBoundingClientRect();
            const clipPath = window.innerWidth > 900 ? (0, $2a8d297402734a47$export$4064ccfd0479f329)({
                height: ticketHeight,
                columnOneWidth: columnOneWidth,
                columnTwoWidth: columnTwoWidth,
                gap: 10,
                gapInset: 10,
                radius: 2
            }) : (0, $2a8d297402734a47$export$c435da95ea8cb26)({
                width: ticketWidth,
                columnOneHeight: columnOneHeight,
                columnTwoHeight: columnTwoHeight,
                gap: 10,
                gapInset: 9,
                radius: 2
            });
            this.container.style.setProperty("--ticket-clip-path", `path("${clipPath}")`);
        };
        this.contestTimestamp = contestTimestamp;
        this.container = document.querySelector("#hero-ticket");
        this.containerResizeObserver = new ResizeObserver(this.setTicketClipPath);
        this.countdown = document.querySelector("#hero-ticket-countdown");
        this.init();
    }
    init() {
        this.setTicketClipPath();
        this.containerResizeObserver.observe(this.container);
        this.updateCountdown();
    }
}


// package.json
var $8ecb29f509dc0bd0$var$version = "1.3.11";
// packages/core/src/maths.ts
function $8ecb29f509dc0bd0$var$clamp(min, input, max) {
    return Math.max(min, Math.min(input, max));
}
function $8ecb29f509dc0bd0$var$lerp(x, y, t) {
    return (1 - t) * x + t * y;
}
function $8ecb29f509dc0bd0$var$damp(x, y, lambda, deltaTime) {
    return $8ecb29f509dc0bd0$var$lerp(x, y, 1 - Math.exp(-lambda * deltaTime));
}
function $8ecb29f509dc0bd0$var$modulo(n, d) {
    return (n % d + d) % d;
}
// packages/core/src/animate.ts
var $8ecb29f509dc0bd0$var$Animate = class {
    isRunning = false;
    value = 0;
    from = 0;
    to = 0;
    currentTime = 0;
    // These are instanciated in the fromTo method
    lerp;
    duration;
    easing;
    onUpdate;
    /**
   * Advance the animation by the given delta time
   *
   * @param deltaTime - The time in seconds to advance the animation
   */ advance(deltaTime) {
        if (!this.isRunning) return;
        let completed = false;
        if (this.duration && this.easing) {
            this.currentTime += deltaTime;
            const linearProgress = $8ecb29f509dc0bd0$var$clamp(0, this.currentTime / this.duration, 1);
            completed = linearProgress >= 1;
            const easedProgress = completed ? 1 : this.easing(linearProgress);
            this.value = this.from + (this.to - this.from) * easedProgress;
        } else if (this.lerp) {
            this.value = $8ecb29f509dc0bd0$var$damp(this.value, this.to, this.lerp * 60, deltaTime);
            if (Math.round(this.value) === this.to) {
                this.value = this.to;
                completed = true;
            }
        } else {
            this.value = this.to;
            completed = true;
        }
        if (completed) this.stop();
        this.onUpdate?.(this.value, completed);
    }
    /** Stop the animation */ stop() {
        this.isRunning = false;
    }
    /**
   * Set up the animation from a starting value to an ending value
   * with optional parameters for lerping, duration, easing, and onUpdate callback
   *
   * @param from - The starting value
   * @param to - The ending value
   * @param options - Options for the animation
   */ fromTo(from, to, { lerp: lerp2, duration: duration, easing: easing, onStart: onStart, onUpdate: onUpdate }) {
        this.from = this.value = from;
        this.to = to;
        this.lerp = lerp2;
        this.duration = duration;
        this.easing = easing;
        this.currentTime = 0;
        this.isRunning = true;
        onStart?.();
        this.onUpdate = onUpdate;
    }
};
// packages/core/src/debounce.ts
function $8ecb29f509dc0bd0$var$debounce(callback, delay) {
    let timer;
    return function(...args) {
        let context = this;
        clearTimeout(timer);
        timer = setTimeout(()=>{
            timer = void 0;
            callback.apply(context, args);
        }, delay);
    };
}
// packages/core/src/dimensions.ts
var $8ecb29f509dc0bd0$var$Dimensions = class {
    constructor(wrapper, content, { autoResize: autoResize = true, debounce: debounceValue = 250 } = {}){
        this.wrapper = wrapper;
        this.content = content;
        if (autoResize) {
            this.debouncedResize = $8ecb29f509dc0bd0$var$debounce(this.resize, debounceValue);
            if (this.wrapper instanceof Window) window.addEventListener("resize", this.debouncedResize, false);
            else {
                this.wrapperResizeObserver = new ResizeObserver(this.debouncedResize);
                this.wrapperResizeObserver.observe(this.wrapper);
            }
            this.contentResizeObserver = new ResizeObserver(this.debouncedResize);
            this.contentResizeObserver.observe(this.content);
        }
        this.resize();
    }
    width = 0;
    height = 0;
    scrollHeight = 0;
    scrollWidth = 0;
    // These are instanciated in the constructor as they need information from the options
    debouncedResize;
    wrapperResizeObserver;
    contentResizeObserver;
    destroy() {
        this.wrapperResizeObserver?.disconnect();
        this.contentResizeObserver?.disconnect();
        if (this.wrapper === window && this.debouncedResize) window.removeEventListener("resize", this.debouncedResize, false);
    }
    resize = ()=>{
        this.onWrapperResize();
        this.onContentResize();
    };
    onWrapperResize = ()=>{
        if (this.wrapper instanceof Window) {
            this.width = window.innerWidth;
            this.height = window.innerHeight;
        } else {
            this.width = this.wrapper.clientWidth;
            this.height = this.wrapper.clientHeight;
        }
    };
    onContentResize = ()=>{
        if (this.wrapper instanceof Window) {
            this.scrollHeight = this.content.scrollHeight;
            this.scrollWidth = this.content.scrollWidth;
        } else {
            this.scrollHeight = this.wrapper.scrollHeight;
            this.scrollWidth = this.wrapper.scrollWidth;
        }
    };
    get limit() {
        return {
            x: this.scrollWidth - this.width,
            y: this.scrollHeight - this.height
        };
    }
};
// packages/core/src/emitter.ts
var $8ecb29f509dc0bd0$var$Emitter = class {
    events = {};
    /**
   * Emit an event with the given data
   * @param event Event name
   * @param args Data to pass to the event handlers
   */ emit(event, ...args) {
        let callbacks = this.events[event] || [];
        for(let i = 0, length = callbacks.length; i < length; i++)callbacks[i]?.(...args);
    }
    /**
   * Add a callback to the event
   * @param event Event name
   * @param cb Callback function
   * @returns Unsubscribe function
   */ on(event, cb) {
        this.events[event]?.push(cb) || (this.events[event] = [
            cb
        ]);
        return ()=>{
            this.events[event] = this.events[event]?.filter((i)=>cb !== i);
        };
    }
    /**
   * Remove a callback from the event
   * @param event Event name
   * @param callback Callback function
   */ off(event, callback) {
        this.events[event] = this.events[event]?.filter((i)=>callback !== i);
    }
    /**
   * Remove all event listeners and clean up
   */ destroy() {
        this.events = {};
    }
};
// packages/core/src/virtual-scroll.ts
var $8ecb29f509dc0bd0$var$LINE_HEIGHT = 100 / 6;
var $8ecb29f509dc0bd0$var$listenerOptions = {
    passive: false
};
var $8ecb29f509dc0bd0$var$VirtualScroll = class {
    constructor(element, options = {
        wheelMultiplier: 1,
        touchMultiplier: 1
    }){
        this.element = element;
        this.options = options;
        window.addEventListener("resize", this.onWindowResize, false);
        this.onWindowResize();
        this.element.addEventListener("wheel", this.onWheel, $8ecb29f509dc0bd0$var$listenerOptions);
        this.element.addEventListener("touchstart", this.onTouchStart, $8ecb29f509dc0bd0$var$listenerOptions);
        this.element.addEventListener("touchmove", this.onTouchMove, $8ecb29f509dc0bd0$var$listenerOptions);
        this.element.addEventListener("touchend", this.onTouchEnd, $8ecb29f509dc0bd0$var$listenerOptions);
    }
    touchStart = {
        x: 0,
        y: 0
    };
    lastDelta = {
        x: 0,
        y: 0
    };
    window = {
        width: 0,
        height: 0
    };
    emitter = new $8ecb29f509dc0bd0$var$Emitter();
    /**
   * Add an event listener for the given event and callback
   *
   * @param event Event name
   * @param callback Callback function
   */ on(event, callback) {
        return this.emitter.on(event, callback);
    }
    /** Remove all event listeners and clean up */ destroy() {
        this.emitter.destroy();
        window.removeEventListener("resize", this.onWindowResize, false);
        this.element.removeEventListener("wheel", this.onWheel, $8ecb29f509dc0bd0$var$listenerOptions);
        this.element.removeEventListener("touchstart", this.onTouchStart, $8ecb29f509dc0bd0$var$listenerOptions);
        this.element.removeEventListener("touchmove", this.onTouchMove, $8ecb29f509dc0bd0$var$listenerOptions);
        this.element.removeEventListener("touchend", this.onTouchEnd, $8ecb29f509dc0bd0$var$listenerOptions);
    }
    /**
   * Event handler for 'touchstart' event
   *
   * @param event Touch event
   */ onTouchStart = (event)=>{
        const { clientX: clientX, clientY: clientY } = event.targetTouches ? event.targetTouches[0] : event;
        this.touchStart.x = clientX;
        this.touchStart.y = clientY;
        this.lastDelta = {
            x: 0,
            y: 0
        };
        this.emitter.emit("scroll", {
            deltaX: 0,
            deltaY: 0,
            event: event
        });
    };
    /** Event handler for 'touchmove' event */ onTouchMove = (event)=>{
        const { clientX: clientX, clientY: clientY } = event.targetTouches ? event.targetTouches[0] : event;
        const deltaX = -(clientX - this.touchStart.x) * this.options.touchMultiplier;
        const deltaY = -(clientY - this.touchStart.y) * this.options.touchMultiplier;
        this.touchStart.x = clientX;
        this.touchStart.y = clientY;
        this.lastDelta = {
            x: deltaX,
            y: deltaY
        };
        this.emitter.emit("scroll", {
            deltaX: deltaX,
            deltaY: deltaY,
            event: event
        });
    };
    onTouchEnd = (event)=>{
        this.emitter.emit("scroll", {
            deltaX: this.lastDelta.x,
            deltaY: this.lastDelta.y,
            event: event
        });
    };
    /** Event handler for 'wheel' event */ onWheel = (event)=>{
        let { deltaX: deltaX, deltaY: deltaY, deltaMode: deltaMode } = event;
        const multiplierX = deltaMode === 1 ? $8ecb29f509dc0bd0$var$LINE_HEIGHT : deltaMode === 2 ? this.window.width : 1;
        const multiplierY = deltaMode === 1 ? $8ecb29f509dc0bd0$var$LINE_HEIGHT : deltaMode === 2 ? this.window.height : 1;
        deltaX *= multiplierX;
        deltaY *= multiplierY;
        deltaX *= this.options.wheelMultiplier;
        deltaY *= this.options.wheelMultiplier;
        this.emitter.emit("scroll", {
            deltaX: deltaX,
            deltaY: deltaY,
            event: event
        });
    };
    onWindowResize = ()=>{
        this.window = {
            width: window.innerWidth,
            height: window.innerHeight
        };
    };
};
// packages/core/src/lenis.ts
var $8ecb29f509dc0bd0$var$defaultEasing = (t)=>Math.min(1, 1.001 - Math.pow(2, -10 * t));
var $8ecb29f509dc0bd0$export$2e2bcd8739ae039 = class {
    _isScrolling = false;
    // true when scroll is animating
    _isStopped = false;
    // true if user should not be able to scroll - enable/disable programmatically
    _isLocked = false;
    // same as isStopped but enabled/disabled when scroll reaches target
    _preventNextNativeScrollEvent = false;
    _resetVelocityTimeout = null;
    __rafID = null;
    /**
   * Whether or not the user is touching the screen
   */ isTouching;
    /**
   * The time in ms since the lenis instance was created
   */ time = 0;
    /**
   * User data that will be forwarded through the scroll event
   *
   * @example
   * lenis.scrollTo(100, {
   *   userData: {
   *     foo: 'bar'
   *   }
   * })
   */ userData = {};
    /**
   * The last velocity of the scroll
   */ lastVelocity = 0;
    /**
   * The current velocity of the scroll
   */ velocity = 0;
    /**
   * The direction of the scroll
   */ direction = 0;
    /**
   * The options passed to the lenis instance
   */ options;
    /**
   * The target scroll value
   */ targetScroll;
    /**
   * The animated scroll value
   */ animatedScroll;
    // These are instanciated here as they don't need information from the options
    animate = new $8ecb29f509dc0bd0$var$Animate();
    emitter = new $8ecb29f509dc0bd0$var$Emitter();
    // These are instanciated in the constructor as they need information from the options
    dimensions;
    // This is not private because it's used in the Snap class
    virtualScroll;
    constructor({ wrapper: wrapper = window, content: content = document.documentElement, eventsTarget: eventsTarget = wrapper, smoothWheel: smoothWheel = true, syncTouch: syncTouch = false, syncTouchLerp: syncTouchLerp = 0.075, touchInertiaExponent: touchInertiaExponent = 1.7, duration: duration, easing: // in seconds
    easing, lerp: lerp2 = 0.1, infinite: infinite = false, orientation: orientation = "vertical", gestureOrientation: // vertical, horizontal
    gestureOrientation = orientation === "horizontal" ? "both" : "vertical", touchMultiplier: // vertical, horizontal, both
    touchMultiplier = 1, wheelMultiplier: wheelMultiplier = 1, autoResize: autoResize = true, prevent: prevent, virtualScroll: virtualScroll, overscroll: overscroll = true, autoRaf: autoRaf = false, anchors: anchors = false, autoToggle: autoToggle = false, allowNestedScroll: // https://caniuse.com/?search=transition-behavior
    allowNestedScroll = false, __experimental__naiveDimensions: __experimental__naiveDimensions = false } = {}){
        window.lenisVersion = $8ecb29f509dc0bd0$var$version;
        if (!wrapper || wrapper === document.documentElement) wrapper = window;
        if (typeof duration === "number" && typeof easing !== "function") easing = $8ecb29f509dc0bd0$var$defaultEasing;
        else if (typeof easing === "function" && typeof duration !== "number") duration = 1;
        this.options = {
            wrapper: wrapper,
            content: content,
            eventsTarget: eventsTarget,
            smoothWheel: smoothWheel,
            syncTouch: syncTouch,
            syncTouchLerp: syncTouchLerp,
            touchInertiaExponent: touchInertiaExponent,
            duration: duration,
            easing: easing,
            lerp: lerp2,
            infinite: infinite,
            gestureOrientation: gestureOrientation,
            orientation: orientation,
            touchMultiplier: touchMultiplier,
            wheelMultiplier: wheelMultiplier,
            autoResize: autoResize,
            prevent: prevent,
            virtualScroll: virtualScroll,
            overscroll: overscroll,
            autoRaf: autoRaf,
            anchors: anchors,
            autoToggle: autoToggle,
            allowNestedScroll: allowNestedScroll,
            __experimental__naiveDimensions: __experimental__naiveDimensions
        };
        this.dimensions = new $8ecb29f509dc0bd0$var$Dimensions(wrapper, content, {
            autoResize: autoResize
        });
        this.updateClassName();
        this.targetScroll = this.animatedScroll = this.actualScroll;
        this.options.wrapper.addEventListener("scroll", this.onNativeScroll, false);
        this.options.wrapper.addEventListener("scrollend", this.onScrollEnd, {
            capture: true
        });
        if (this.options.anchors && this.options.wrapper === window) this.options.wrapper.addEventListener("click", this.onClick, false);
        this.options.wrapper.addEventListener("pointerdown", this.onPointerDown, false);
        this.virtualScroll = new $8ecb29f509dc0bd0$var$VirtualScroll(eventsTarget, {
            touchMultiplier: touchMultiplier,
            wheelMultiplier: wheelMultiplier
        });
        this.virtualScroll.on("scroll", this.onVirtualScroll);
        if (this.options.autoToggle) this.rootElement.addEventListener("transitionend", this.onTransitionEnd, {
            passive: true
        });
        if (this.options.autoRaf) this.__rafID = requestAnimationFrame(this.raf);
    }
    /**
   * Destroy the lenis instance, remove all event listeners and clean up the class name
   */ destroy() {
        this.emitter.destroy();
        this.options.wrapper.removeEventListener("scroll", this.onNativeScroll, false);
        this.options.wrapper.removeEventListener("scrollend", this.onScrollEnd, {
            capture: true
        });
        this.options.wrapper.removeEventListener("pointerdown", this.onPointerDown, false);
        if (this.options.anchors && this.options.wrapper === window) this.options.wrapper.removeEventListener("click", this.onClick, false);
        this.virtualScroll.destroy();
        this.dimensions.destroy();
        this.cleanUpClassName();
        if (this.__rafID) cancelAnimationFrame(this.__rafID);
    }
    on(event, callback) {
        return this.emitter.on(event, callback);
    }
    off(event, callback) {
        return this.emitter.off(event, callback);
    }
    onScrollEnd = (e)=>{
        if (!(e instanceof CustomEvent)) {
            if (this.isScrolling === "smooth" || this.isScrolling === false) e.stopPropagation();
        }
    };
    dispatchScrollendEvent = ()=>{
        this.options.wrapper.dispatchEvent(new CustomEvent("scrollend", {
            bubbles: this.options.wrapper === window,
            // cancelable: false,
            detail: {
                lenisScrollEnd: true
            }
        }));
    };
    onTransitionEnd = (event)=>{
        if (event.propertyName.includes("overflow")) {
            const property = this.isHorizontal ? "overflow-x" : "overflow-y";
            const overflow = getComputedStyle(this.rootElement)[property];
            if ([
                "hidden",
                "clip"
            ].includes(overflow)) this.internalStop();
            else this.internalStart();
        }
    };
    setScroll(scroll) {
        if (this.isHorizontal) this.options.wrapper.scrollTo({
            left: scroll,
            behavior: "instant"
        });
        else this.options.wrapper.scrollTo({
            top: scroll,
            behavior: "instant"
        });
    }
    onClick = (event)=>{
        const path = event.composedPath();
        const anchor = path.find((node)=>node instanceof HTMLAnchorElement && (node.getAttribute("href")?.startsWith("#") || node.getAttribute("href")?.startsWith("/#") || node.getAttribute("href")?.startsWith("./#")));
        if (anchor) {
            const id = anchor.getAttribute("href");
            if (id) {
                const options = typeof this.options.anchors === "object" && this.options.anchors ? this.options.anchors : void 0;
                let target = `#${id.split("#")[1]}`;
                if ([
                    "#",
                    "/#",
                    "./#",
                    "#top",
                    "/#top",
                    "./#top"
                ].includes(id)) target = 0;
                this.scrollTo(target, options);
            }
        }
    };
    onPointerDown = (event)=>{
        if (event.button === 1) this.reset();
    };
    onVirtualScroll = (data)=>{
        if (typeof this.options.virtualScroll === "function" && this.options.virtualScroll(data) === false) return;
        const { deltaX: deltaX, deltaY: deltaY, event: event } = data;
        this.emitter.emit("virtual-scroll", {
            deltaX: deltaX,
            deltaY: deltaY,
            event: event
        });
        if (event.ctrlKey) return;
        if (event.lenisStopPropagation) return;
        const isTouch = event.type.includes("touch");
        const isWheel = event.type.includes("wheel");
        this.isTouching = event.type === "touchstart" || event.type === "touchmove";
        const isClickOrTap = deltaX === 0 && deltaY === 0;
        const isTapToStop = this.options.syncTouch && isTouch && event.type === "touchstart" && isClickOrTap && !this.isStopped && !this.isLocked;
        if (isTapToStop) {
            this.reset();
            return;
        }
        const isUnknownGesture = this.options.gestureOrientation === "vertical" && deltaY === 0 || this.options.gestureOrientation === "horizontal" && deltaX === 0;
        if (isClickOrTap || isUnknownGesture) return;
        let composedPath = event.composedPath();
        composedPath = composedPath.slice(0, composedPath.indexOf(this.rootElement));
        const prevent = this.options.prevent;
        if (!!composedPath.find((node)=>node instanceof HTMLElement && (typeof prevent === "function" && prevent?.(node) || node.hasAttribute?.("data-lenis-prevent") || isTouch && node.hasAttribute?.("data-lenis-prevent-touch") || isWheel && node.hasAttribute?.("data-lenis-prevent-wheel") || this.options.allowNestedScroll && this.checkNestedScroll(node, {
                deltaX: deltaX,
                deltaY: deltaY
            })))) return;
        if (this.isStopped || this.isLocked) {
            if (event.cancelable) event.preventDefault();
            return;
        }
        const isSmooth = this.options.syncTouch && isTouch || this.options.smoothWheel && isWheel;
        if (!isSmooth) {
            this.isScrolling = "native";
            this.animate.stop();
            event.lenisStopPropagation = true;
            return;
        }
        let delta = deltaY;
        if (this.options.gestureOrientation === "both") delta = Math.abs(deltaY) > Math.abs(deltaX) ? deltaY : deltaX;
        else if (this.options.gestureOrientation === "horizontal") delta = deltaX;
        if (!this.options.overscroll || this.options.infinite || this.options.wrapper !== window && this.limit > 0 && (this.animatedScroll > 0 && this.animatedScroll < this.limit || this.animatedScroll === 0 && deltaY > 0 || this.animatedScroll === this.limit && deltaY < 0)) event.lenisStopPropagation = true;
        if (event.cancelable) event.preventDefault();
        const isSyncTouch = isTouch && this.options.syncTouch;
        const isTouchEnd = isTouch && event.type === "touchend";
        const hasTouchInertia = isTouchEnd;
        if (hasTouchInertia) delta = Math.sign(this.velocity) * Math.pow(Math.abs(this.velocity), this.options.touchInertiaExponent);
        this.scrollTo(this.targetScroll + delta, {
            programmatic: false,
            ...isSyncTouch ? {
                lerp: hasTouchInertia ? this.options.syncTouchLerp : 1
            } : {
                lerp: this.options.lerp,
                duration: this.options.duration,
                easing: this.options.easing
            }
        });
    };
    /**
   * Force lenis to recalculate the dimensions
   */ resize() {
        this.dimensions.resize();
        this.animatedScroll = this.targetScroll = this.actualScroll;
        this.emit();
    }
    emit() {
        this.emitter.emit("scroll", this);
    }
    onNativeScroll = ()=>{
        if (this._resetVelocityTimeout !== null) {
            clearTimeout(this._resetVelocityTimeout);
            this._resetVelocityTimeout = null;
        }
        if (this._preventNextNativeScrollEvent) {
            this._preventNextNativeScrollEvent = false;
            return;
        }
        if (this.isScrolling === false || this.isScrolling === "native") {
            const lastScroll = this.animatedScroll;
            this.animatedScroll = this.targetScroll = this.actualScroll;
            this.lastVelocity = this.velocity;
            this.velocity = this.animatedScroll - lastScroll;
            this.direction = Math.sign(this.animatedScroll - lastScroll);
            if (!this.isStopped) this.isScrolling = "native";
            this.emit();
            if (this.velocity !== 0) this._resetVelocityTimeout = setTimeout(()=>{
                this.lastVelocity = this.velocity;
                this.velocity = 0;
                this.isScrolling = false;
                this.emit();
            }, 400);
        }
    };
    reset() {
        this.isLocked = false;
        this.isScrolling = false;
        this.animatedScroll = this.targetScroll = this.actualScroll;
        this.lastVelocity = this.velocity = 0;
        this.animate.stop();
    }
    /**
   * Start lenis scroll after it has been stopped
   */ start() {
        if (!this.isStopped) return;
        if (this.options.autoToggle) {
            this.rootElement.style.removeProperty("overflow");
            return;
        }
        this.internalStart();
    }
    internalStart() {
        if (!this.isStopped) return;
        this.reset();
        this.isStopped = false;
        this.emit();
    }
    /**
   * Stop lenis scroll
   */ stop() {
        if (this.isStopped) return;
        if (this.options.autoToggle) {
            this.rootElement.style.setProperty("overflow", "clip");
            return;
        }
        this.internalStop();
    }
    internalStop() {
        if (this.isStopped) return;
        this.reset();
        this.isStopped = true;
        this.emit();
    }
    /**
   * RequestAnimationFrame for lenis
   *
   * @param time The time in ms from an external clock like `requestAnimationFrame` or Tempus
   */ raf = (time)=>{
        const deltaTime = time - (this.time || time);
        this.time = time;
        this.animate.advance(deltaTime * 1e-3);
        if (this.options.autoRaf) this.__rafID = requestAnimationFrame(this.raf);
    };
    /**
   * Scroll to a target value
   *
   * @param target The target value to scroll to
   * @param options The options for the scroll
   *
   * @example
   * lenis.scrollTo(100, {
   *   offset: 100,
   *   duration: 1,
   *   easing: (t) => 1 - Math.cos((t * Math.PI) / 2),
   *   lerp: 0.1,
   *   onStart: () => {
   *     console.log('onStart')
   *   },
   *   onComplete: () => {
   *     console.log('onComplete')
   *   },
   * })
   */ scrollTo(target, { offset: offset = 0, immediate: immediate = false, lock: lock = false, duration: duration = this.options.duration, easing: easing = this.options.easing, lerp: lerp2 = this.options.lerp, onStart: onStart, onComplete: onComplete, force: force = false, programmatic: // scroll even if stopped
    programmatic = true, userData: // called from outside of the class
    userData } = {}) {
        if ((this.isStopped || this.isLocked) && !force) return;
        if (typeof target === "string" && [
            "top",
            "left",
            "start"
        ].includes(target)) target = 0;
        else if (typeof target === "string" && [
            "bottom",
            "right",
            "end"
        ].includes(target)) target = this.limit;
        else {
            let node;
            if (typeof target === "string") node = document.querySelector(target);
            else if (target instanceof HTMLElement && target?.nodeType) node = target;
            if (node) {
                if (this.options.wrapper !== window) {
                    const wrapperRect = this.rootElement.getBoundingClientRect();
                    offset -= this.isHorizontal ? wrapperRect.left : wrapperRect.top;
                }
                const rect = node.getBoundingClientRect();
                target = (this.isHorizontal ? rect.left : rect.top) + this.animatedScroll;
            }
        }
        if (typeof target !== "number") return;
        target += offset;
        target = Math.round(target);
        if (this.options.infinite) {
            if (programmatic) {
                this.targetScroll = this.animatedScroll = this.scroll;
                const distance = target - this.animatedScroll;
                if (distance > this.limit / 2) target = target - this.limit;
                else if (distance < -this.limit / 2) target = target + this.limit;
            }
        } else target = $8ecb29f509dc0bd0$var$clamp(0, target, this.limit);
        if (target === this.targetScroll) {
            onStart?.(this);
            onComplete?.(this);
            return;
        }
        this.userData = userData ?? {};
        if (immediate) {
            this.animatedScroll = this.targetScroll = target;
            this.setScroll(this.scroll);
            this.reset();
            this.preventNextNativeScrollEvent();
            this.emit();
            onComplete?.(this);
            this.userData = {};
            requestAnimationFrame(()=>{
                this.dispatchScrollendEvent();
            });
            return;
        }
        if (!programmatic) this.targetScroll = target;
        if (typeof duration === "number" && typeof easing !== "function") easing = $8ecb29f509dc0bd0$var$defaultEasing;
        else if (typeof easing === "function" && typeof duration !== "number") duration = 1;
        this.animate.fromTo(this.animatedScroll, target, {
            duration: duration,
            easing: easing,
            lerp: lerp2,
            onStart: ()=>{
                if (lock) this.isLocked = true;
                this.isScrolling = "smooth";
                onStart?.(this);
            },
            onUpdate: (value, completed)=>{
                this.isScrolling = "smooth";
                this.lastVelocity = this.velocity;
                this.velocity = value - this.animatedScroll;
                this.direction = Math.sign(this.velocity);
                this.animatedScroll = value;
                this.setScroll(this.scroll);
                if (programmatic) this.targetScroll = value;
                if (!completed) this.emit();
                if (completed) {
                    this.reset();
                    this.emit();
                    onComplete?.(this);
                    this.userData = {};
                    requestAnimationFrame(()=>{
                        this.dispatchScrollendEvent();
                    });
                    this.preventNextNativeScrollEvent();
                }
            }
        });
    }
    preventNextNativeScrollEvent() {
        this._preventNextNativeScrollEvent = true;
        requestAnimationFrame(()=>{
            this._preventNextNativeScrollEvent = false;
        });
    }
    checkNestedScroll(node, { deltaX: deltaX, deltaY: deltaY }) {
        const time = Date.now();
        const cache = node._lenis ??= {};
        let hasOverflowX, hasOverflowY, isScrollableX, isScrollableY, scrollWidth, scrollHeight, clientWidth, clientHeight;
        const gestureOrientation = this.options.gestureOrientation;
        if (time - (cache.time ?? 0) > 2e3) {
            cache.time = Date.now();
            const computedStyle = window.getComputedStyle(node);
            cache.computedStyle = computedStyle;
            const overflowXString = computedStyle.overflowX;
            const overflowYString = computedStyle.overflowY;
            hasOverflowX = [
                "auto",
                "overlay",
                "scroll"
            ].includes(overflowXString);
            hasOverflowY = [
                "auto",
                "overlay",
                "scroll"
            ].includes(overflowYString);
            cache.hasOverflowX = hasOverflowX;
            cache.hasOverflowY = hasOverflowY;
            if (!hasOverflowX && !hasOverflowY) return false;
            if (gestureOrientation === "vertical" && !hasOverflowY) return false;
            if (gestureOrientation === "horizontal" && !hasOverflowX) return false;
            scrollWidth = node.scrollWidth;
            scrollHeight = node.scrollHeight;
            clientWidth = node.clientWidth;
            clientHeight = node.clientHeight;
            isScrollableX = scrollWidth > clientWidth;
            isScrollableY = scrollHeight > clientHeight;
            cache.isScrollableX = isScrollableX;
            cache.isScrollableY = isScrollableY;
            cache.scrollWidth = scrollWidth;
            cache.scrollHeight = scrollHeight;
            cache.clientWidth = clientWidth;
            cache.clientHeight = clientHeight;
        } else {
            isScrollableX = cache.isScrollableX;
            isScrollableY = cache.isScrollableY;
            hasOverflowX = cache.hasOverflowX;
            hasOverflowY = cache.hasOverflowY;
            scrollWidth = cache.scrollWidth;
            scrollHeight = cache.scrollHeight;
            clientWidth = cache.clientWidth;
            clientHeight = cache.clientHeight;
        }
        if (!hasOverflowX && !hasOverflowY || !isScrollableX && !isScrollableY) return false;
        if (gestureOrientation === "vertical" && (!hasOverflowY || !isScrollableY)) return false;
        if (gestureOrientation === "horizontal" && (!hasOverflowX || !isScrollableX)) return false;
        let orientation;
        if (gestureOrientation === "horizontal") orientation = "x";
        else if (gestureOrientation === "vertical") orientation = "y";
        else {
            const isScrollingX = deltaX !== 0;
            const isScrollingY = deltaY !== 0;
            if (isScrollingX && hasOverflowX && isScrollableX) orientation = "x";
            if (isScrollingY && hasOverflowY && isScrollableY) orientation = "y";
        }
        if (!orientation) return false;
        let scroll, maxScroll, delta, hasOverflow, isScrollable;
        if (orientation === "x") {
            scroll = node.scrollLeft;
            maxScroll = scrollWidth - clientWidth;
            delta = deltaX;
            hasOverflow = hasOverflowX;
            isScrollable = isScrollableX;
        } else if (orientation === "y") {
            scroll = node.scrollTop;
            maxScroll = scrollHeight - clientHeight;
            delta = deltaY;
            hasOverflow = hasOverflowY;
            isScrollable = isScrollableY;
        } else return false;
        const willScroll = delta > 0 ? scroll < maxScroll : scroll > 0;
        return willScroll && hasOverflow && isScrollable;
    }
    /**
   * The root element on which lenis is instanced
   */ get rootElement() {
        return this.options.wrapper === window ? document.documentElement : this.options.wrapper;
    }
    /**
   * The limit which is the maximum scroll value
   */ get limit() {
        if (this.options.__experimental__naiveDimensions) {
            if (this.isHorizontal) return this.rootElement.scrollWidth - this.rootElement.clientWidth;
            else return this.rootElement.scrollHeight - this.rootElement.clientHeight;
        } else return this.dimensions.limit[this.isHorizontal ? "x" : "y"];
    }
    /**
   * Whether or not the scroll is horizontal
   */ get isHorizontal() {
        return this.options.orientation === "horizontal";
    }
    /**
   * The actual scroll value
   */ get actualScroll() {
        const wrapper = this.options.wrapper;
        return this.isHorizontal ? wrapper.scrollX ?? wrapper.scrollLeft : wrapper.scrollY ?? wrapper.scrollTop;
    }
    /**
   * The current scroll value
   */ get scroll() {
        return this.options.infinite ? $8ecb29f509dc0bd0$var$modulo(this.animatedScroll, this.limit) : this.animatedScroll;
    }
    /**
   * The progress of the scroll relative to the limit
   */ get progress() {
        return this.limit === 0 ? 1 : this.scroll / this.limit;
    }
    /**
   * Current scroll state
   */ get isScrolling() {
        return this._isScrolling;
    }
    set isScrolling(value) {
        if (this._isScrolling !== value) {
            this._isScrolling = value;
            this.updateClassName();
        }
    }
    /**
   * Check if lenis is stopped
   */ get isStopped() {
        return this._isStopped;
    }
    set isStopped(value) {
        if (this._isStopped !== value) {
            this._isStopped = value;
            this.updateClassName();
        }
    }
    /**
   * Check if lenis is locked
   */ get isLocked() {
        return this._isLocked;
    }
    set isLocked(value) {
        if (this._isLocked !== value) {
            this._isLocked = value;
            this.updateClassName();
        }
    }
    /**
   * Check if lenis is smooth scrolling
   */ get isSmooth() {
        return this.isScrolling === "smooth";
    }
    /**
   * The class name applied to the wrapper element
   */ get className() {
        let className = "lenis";
        if (this.options.autoToggle) className += " lenis-autoToggle";
        if (this.isStopped) className += " lenis-stopped";
        if (this.isLocked) className += " lenis-locked";
        if (this.isScrolling) className += " lenis-scrolling";
        if (this.isScrolling === "smooth") className += " lenis-smooth";
        return className;
    }
    updateClassName() {
        this.cleanUpClassName();
        this.rootElement.className = `${this.rootElement.className} ${this.className}`.trim();
    }
    cleanUpClassName() {
        this.rootElement.className = this.rootElement.className.replace(/lenis(-\w+)?/g, "").trim();
    }
};



const $44475dd3aa49bf94$var$CHART_SVG_OFFSET_END_X = 88;
const $44475dd3aa49bf94$var$CHART_SVG_OFFSET_START_X = 64;
const $44475dd3aa49bf94$var$CHART_COLUMN_MIN_WIDTH = 80;
const $44475dd3aa49bf94$var$CHART_HEIGHT = 220;
const $44475dd3aa49bf94$var$ANIMATION_DURATION = 440;
const $44475dd3aa49bf94$var$HOVER_ANIMATION_DURATION = 640;
const $44475dd3aa49bf94$var$MIN_GRID_LINES_PER_GAME = 4;
const $44475dd3aa49bf94$var$BASE_GRID_LINES_COLUMN_SPACE = 40;
class $44475dd3aa49bf94$export$8af7671b8639436d {
    constructor({ container: container, data: data, dataKey: dataKey, dataKeyAbbreviation: dataKeyAbbreviation, onChartContainerScroll: onChartContainerScroll }){
        this.maxDataValue = 4;
        this.chartPoints = [];
        this.chartWidth = 0;
        this.currentHoverIndex = 0;
        this.chartSVGMinWidth = 0;
        this.totalGames = 0;
        this.hoverPoint = [
            0,
            0
        ];
        this.animationStartChartPoints = [];
        this.targetChartPoints = [];
        this.hoverAnimationStartHoverPoint = [
            0,
            0
        ];
        this.hoverAnimationTargetHoverPoint = [
            0,
            0
        ];
        this.animationStartTime = 0;
        this.hoverAnimationStartTime = 0;
        this.hasAddedMouseEventListeners = false;
        this.prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        this.init = ({ updateXaxis: updateXaxis, updateYaxis: updateYaxis })=>{
            this.lineChartContainer.appendChild(this.lineChart);
            this.totalGames = this.data.length;
            this.chartSVGMinWidth = this.totalGames * $44475dd3aa49bf94$var$CHART_COLUMN_MIN_WIDTH;
            this.chartWidth = Math.max(this.lineChartContainer.getBoundingClientRect().width - $44475dd3aa49bf94$var$CHART_SVG_OFFSET_END_X, this.chartSVGMinWidth);
            this.lineChart.style.setProperty("--chart-width", `${this.chartWidth}px`);
            this.currentHoverIndex = this.data.findIndex((_, index)=>!this.data[index + 1]?.gameData);
            this.setAxisLabels({
                isUpdateXaxis: updateXaxis,
                isUpdateYaxis: updateYaxis
            });
            this.updateChartPoints();
            this.lineChartContainerResizeObserver.observe(this.lineChartContainer);
            const polylineSVG = this.lineChartContainer.querySelector("#stats-line-chart-data-chart");
            if (this.chartPoints.length && !this.hasAddedMouseEventListeners) {
                polylineSVG.addEventListener("mouseenter", this.onLineChartMouseMove);
                polylineSVG.addEventListener("mousemove", this.onLineChartMouseMove);
                polylineSVG.addEventListener("mouseleave", this.onLineChartMouseLeave);
                this.hasAddedMouseEventListeners = true;
            }
            const dataContainer = this.lineChartContainer.querySelector("#stats-line-chart-data-container");
            const lastGameWithDataIndex = this.chartPoints.length - 1;
            if (lastGameWithDataIndex >= 0) {
                const lastGameWithDataLabel = dataContainer.querySelectorAll(".stats-line-chart__x-axis-label-value")[lastGameWithDataIndex];
                const dataContainerScrollX = lastGameWithDataLabel.offsetLeft - dataContainer.getBoundingClientRect().width / 2 + lastGameWithDataLabel.getBoundingClientRect().width;
                dataContainer.scrollLeft = dataContainerScrollX;
                const crosshair = polylineSVG.querySelector("#stats-line-chart-data-crosshair");
                crosshair.style.removeProperty("display");
                const gridLineActiveLine = this.lineChartContainer.querySelector("#stats-line-chart-gridlines-active-line");
                gridLineActiveLine.style.removeProperty("display");
                this.tooltip.style.removeProperty("display");
            }
            if (this.onChartContainerScroll) dataContainer.addEventListener("scroll", this.onChartContainerScroll);
        };
        this.onLineChartMouseMove = (e)=>{
            const stepX = this.chartWidth / (this.totalGames - 1 || 1);
            const hoverIndex = Math.round(e.offsetX / stepX);
            const nextHoverIndex = Math.min(hoverIndex, this.chartPoints.length - 1);
            if (this.currentHoverIndex === nextHoverIndex) return;
            this.currentHoverIndex = nextHoverIndex;
            this.hoverAnimationStartHoverPoint = this.hoverPoint;
            this.hoverAnimationTargetHoverPoint = this.chartPoints[this.currentHoverIndex];
            if (this.hoverAnimationFrameId) cancelAnimationFrame(this.hoverAnimationFrameId);
            this.hoverAnimationStartTime = performance.now();
            this.hoverAnimationFrameId = requestAnimationFrame(this.animateHoverData);
        };
        this.onLineChartMouseLeave = ()=>{
            this.currentHoverIndex = this.chartPoints.length - 1;
            this.hoverAnimationStartHoverPoint = this.hoverPoint;
            this.hoverAnimationTargetHoverPoint = this.chartPoints[this.currentHoverIndex];
            if (this.hoverAnimationFrameId) cancelAnimationFrame(this.hoverAnimationFrameId);
            this.hoverAnimationStartTime = performance.now();
            this.hoverAnimationFrameId = requestAnimationFrame(this.animateHoverData);
        };
        this.setAxisLabels = ({ isUpdateXaxis: isUpdateXaxis, isUpdateYaxis: isUpdateYaxis })=>{
            const maxValue = Math.max(1, ...this.data.map((item)=>item.gameData?.[this.currDataKey] || 0).filter((value)=>value !== undefined));
            const stepGap = Math.ceil(maxValue / 4);
            this.maxDataValue = stepGap * 4;
            const yAxisLabels = this.lineChart.querySelectorAll(".stats-line-chart__y-axis-label");
            const totalLabels = yAxisLabels.length;
            if (isUpdateYaxis) {
                const yAxisLabelsContainer = this.lineChart.querySelector("#stats-line-y-axis-labels");
                yAxisLabelsContainer.classList.add("stats-line-chart__y-axis--updating");
                requestAnimationFrame(()=>{
                    yAxisLabelsContainer.classList.remove("stats-line-chart__y-axis--updating");
                });
            }
            yAxisLabels.forEach((label, index)=>{
                const value = ((totalLabels - index) * stepGap).toString();
                if (isUpdateYaxis && label.textContent) {
                    const lastLabelElement = label.lastChild;
                    lastLabelElement.setAttribute("aria-hidden", "true");
                    const nextLabelElement = lastLabelElement.cloneNode(true);
                    nextLabelElement.removeAttribute("aria-hidden");
                    nextLabelElement.textContent = value;
                    label.innerHTML = "";
                    label.appendChild(lastLabelElement);
                    label.appendChild(nextLabelElement);
                    return;
                }
                label.innerHTML = `<span>${value}</span>`;
            });
            const xAxisLabels = this.lineChart.querySelector("#stats-line-x-axis-labels");
            if (isUpdateXaxis) {
                xAxisLabels.classList.add("stats-line-chart__x-axis-labels--updating");
                requestAnimationFrame(()=>{
                    xAxisLabels.classList.remove("stats-line-chart__x-axis-labels--updating");
                });
            }
            xAxisLabels.innerHTML = "";
            xAxisLabels.style.setProperty("--total-items", this.totalGames.toString());
            this.data.forEach((statData)=>{
                const label = document.createElement("span");
                const labelInnerElement = document.createElement("span");
                labelInnerElement.className = "stats-line-chart__x-axis-label-value";
                labelInnerElement.classList.toggle("stats-line-chart__x-axis-label-value--future", !statData.gameData);
                labelInnerElement.textContent = statData.dateShort;
                label.appendChild(labelInnerElement);
                xAxisLabels.appendChild(label);
            });
        };
        this.setGridLinesDashes = ()=>{
            const gridLinesSVG = this.lineChartContainer.querySelector("#stats-line-chart-gridlines");
            if (!gridLinesSVG) return;
            const height = 165;
            gridLinesSVG.setAttribute("width", this.chartWidth.toString());
            gridLinesSVG.setAttribute("viewBox", `0 0 ${this.chartWidth} 165`);
            const gridLineMask = gridLinesSVG.querySelector("#stats-line-chart-gridlines-mask");
            gridLineMask.innerHTML = "";
            const lineWidth = 1;
            const spaceBetweenGames = (this.chartWidth - lineWidth) / (this.totalGames - 1);
            const linesPerGame = Math.max($44475dd3aa49bf94$var$MIN_GRID_LINES_PER_GAME, Math.floor(spaceBetweenGames / $44475dd3aa49bf94$var$BASE_GRID_LINES_COLUMN_SPACE));
            const numberOfLines = (this.totalGames - 1) * linesPerGame + 1;
            const columnSpaceBetweenLines = (this.chartWidth - lineWidth) / (numberOfLines - 1);
            const numberOfRows = 7;
            const dashHeight = 0.1;
            const totalDashGap = height - numberOfRows * dashHeight;
            const dashGap = totalDashGap / (numberOfRows - 1);
            for(let i = 0; i < numberOfLines; i++){
                const line = document.createElementNS("http://www.w3.org/2000/svg", "line");
                const x = i === 0 ? 0 : i * columnSpaceBetweenLines + lineWidth;
                line.setAttribute("x1", x.toString());
                line.setAttribute("y1", "0");
                line.setAttribute("x2", x.toString());
                line.setAttribute("y2", height.toString());
                line.setAttribute("stroke", "#FFFFFF");
                line.setAttribute("stroke-linecap", "square");
                line.setAttribute("stroke-dasharray", `0.1 ${dashGap}`);
                gridLineMask.appendChild(line);
            }
            const gridLinesStickyLine = this.lineChartContainer.querySelector("#stats-line-chart-gridlines-sticky-line");
            gridLinesStickyLine.setAttribute("y2", height.toString());
            gridLinesStickyLine?.setAttribute("stroke-dasharray", `0.1 ${dashGap}`);
            const gridLineActiveLine = gridLinesSVG.querySelector("#stats-line-chart-gridlines-active-line");
            gridLineActiveLine.setAttribute("y2", height.toString());
            gridLineActiveLine.setAttribute("stroke-dasharray", `0.1 ${dashGap}`);
            this.setActiveGridBar();
        };
        this.setActiveGridBar = ()=>{
            const gridLineActiveLine = this.lineChartContainer.querySelector("#stats-line-chart-gridlines-active-line");
            if (!this.chartPoints.length) {
                gridLineActiveLine?.style.setProperty("display", "none");
                return;
            }
            gridLineActiveLine?.style.setProperty("transform", `translateX(${this.hoverPoint[0]}px)`);
        };
        this.updateChartPoints = ()=>{
            const chartPoints = [];
            const stepX = this.chartWidth / (this.totalGames - 1 || 1);
            this.data.forEach((item, index)=>{
                const gameData = item.gameData;
                if (!gameData) return;
                const x = index * stepX;
                const y = $44475dd3aa49bf94$var$CHART_HEIGHT - gameData[this.currDataKey] / (this.maxDataValue || 1) * $44475dd3aa49bf94$var$CHART_HEIGHT;
                chartPoints.push([
                    x,
                    y
                ]);
            });
            if (this.chartPoints.length) {
                this.animationStartChartPoints = this.chartPoints;
                this.targetChartPoints = chartPoints;
                if (this.animationsFrameId) cancelAnimationFrame(this.animationsFrameId);
                this.animationStartTime = performance.now();
                this.animationsFrameId = requestAnimationFrame(this.animateChartPoints);
            } else {
                this.chartPoints = chartPoints;
                this.hoverPoint = this.chartPoints.at(-1);
                this.setDataPolyline();
                this.setDataGradient();
                this.setGridLinesDashes();
                this.setTooltip();
            }
        };
        this.animateChartPoints = (timestamp)=>{
            const elapsed = timestamp - this.animationStartTime;
            const animationDuration = this.prefersReducedMotion ? 10 : $44475dd3aa49bf94$var$ANIMATION_DURATION;
            const relativeProgress = Math.min(elapsed / animationDuration, 1);
            const easedProgress = (0, $570588f05c4206f4$export$1157fb72e7fbceb5)(relativeProgress);
            this.chartPoints = this.animationStartChartPoints.map((startPoint, index)=>{
                const targetPoint = this.targetChartPoints[index];
                const x = (0, $cdb99edfce3a690f$export$3a89f8d6f6bf6c9f)(startPoint[0], targetPoint[0], easedProgress);
                const y = (0, $cdb99edfce3a690f$export$3a89f8d6f6bf6c9f)(startPoint[1], targetPoint[1], easedProgress);
                return [
                    x,
                    y
                ];
            });
            this.hoverPoint = this.chartPoints.at(-1);
            this.setDataPolyline();
            this.setDataGradient();
            this.setGridLinesDashes();
            this.setTooltip();
            if (easedProgress < 1) this.animationsFrameId = requestAnimationFrame(this.animateChartPoints);
        };
        this.animateHoverData = (timestamp)=>{
            if (!this.hoverAnimationStartHoverPoint || !this.hoverAnimationTargetHoverPoint) return;
            const elapsed = timestamp - this.hoverAnimationStartTime;
            const animationDuration = this.prefersReducedMotion ? 10 : $44475dd3aa49bf94$var$HOVER_ANIMATION_DURATION;
            const relativeProgress = Math.min(elapsed / animationDuration, 1);
            const easedProgress = (0, $570588f05c4206f4$export$1157fb72e7fbceb5)(relativeProgress);
            const hoverPointX = (0, $cdb99edfce3a690f$export$3a89f8d6f6bf6c9f)(this.hoverAnimationStartHoverPoint[0], this.hoverAnimationTargetHoverPoint[0], easedProgress);
            const hoverPointY = (0, $cdb99edfce3a690f$export$3a89f8d6f6bf6c9f)(this.hoverAnimationStartHoverPoint[1], this.hoverAnimationTargetHoverPoint[1], easedProgress);
            this.hoverPoint = [
                Math.max(hoverPointX, 0),
                hoverPointY
            ];
            this.setActiveGridBar();
            this.setTooltip();
            this.setDataGradient();
            if (easedProgress < 1) this.hoverAnimationFrameId = requestAnimationFrame(this.animateHoverData);
        };
        this.setDataPolyline = ()=>{
            const polylineSVG = this.lineChartContainer.querySelector("#stats-line-chart-data-chart");
            if (!polylineSVG) return;
            polylineSVG.setAttribute("width", this.chartWidth.toString());
            polylineSVG.setAttribute("viewBox", `0 0 ${this.chartWidth} ${$44475dd3aa49bf94$var$CHART_HEIGHT}`);
            const polyline = polylineSVG.querySelector("polyline");
            polyline.setAttribute("points", this.chartPoints.join(" "));
            const crosshair = polylineSVG.querySelector("#stats-line-chart-data-crosshair");
            if (this.chartPoints.length) crosshair.setAttribute("transform", `translate(${this.chartPoints.at(-1)[0]} ${this.chartPoints.at(-1)[1]})`);
            else crosshair.style.setProperty("display", `none`);
        };
        this.setDataGradient = ()=>{
            const polygon = this.lineChartContainer.querySelector("#stats-line-chart-data-gradient");
            if (!polygon) return;
            if (!this.chartPoints.length) {
                polygon.setAttribute("points", "");
                return;
            }
            const stepX = this.chartWidth / (this.totalGames - 1 || 1);
            const polygonPoints = [
                ...this.chartPoints,
                [
                    this.chartPoints.at(-1)[0],
                    $44475dd3aa49bf94$var$CHART_HEIGHT
                ],
                [
                    0,
                    $44475dd3aa49bf94$var$CHART_HEIGHT
                ]
            ];
            polygon.setAttribute("points", polygonPoints.join(" "));
            const polygonGradient = this.lineChartContainer.querySelector("#stats-line-chart-data-radial-gradient");
            polygonGradient.setAttribute("cx", this.hoverPoint[0].toString());
            polygonGradient.setAttribute("cy", "0");
            polygonGradient.setAttribute("r", (stepX * 3).toString());
            const gradientMaskRect = this.lineChartContainer.querySelector("#stats-line-chart-data-gradient-mask rect");
            gradientMaskRect.setAttribute("width", this.hoverPoint[0].toString());
        };
        this.setTooltip = ()=>{
            const tooltipDataElements = this.tooltip.querySelectorAll("span");
            if (this.currentHoverIndex < 0) {
                this.tooltip.style.setProperty("display", "none");
                return;
            }
            const currentGameData = this.data[this.currentHoverIndex].gameData;
            if (!currentGameData) {
                this.tooltip.style.setProperty("display", "none");
                return;
            }
            const toolTipX = this.hoverPoint[0] + $44475dd3aa49bf94$var$CHART_SVG_OFFSET_START_X;
            const toolTipY = this.hoverPoint[1];
            this.tooltip.style.setProperty("transform", `translate(${toolTipX}px, ${toolTipY}px)`);
            tooltipDataElements[0].textContent = `${currentGameData[this.currDataKey]} ${this.dataKeyAbbreviation[this.currDataKey]}`;
            tooltipDataElements[1].textContent = this.data[this.currentHoverIndex].date;
            tooltipDataElements[2].textContent = `VS. ${this.data[this.currentHoverIndex].team}`;
        };
        this.onContainerResize = ()=>{
            this.chartWidth = Math.max(this.lineChartContainer.getBoundingClientRect().width - $44475dd3aa49bf94$var$CHART_SVG_OFFSET_END_X, this.chartSVGMinWidth);
            this.lineChart.style.setProperty("--chart-width", `${this.chartWidth}px`);
            this.updateChartPoints();
        };
        this.setData = (data)=>{
            this.chartPoints = [];
            this.data = data.map(({ gameData: gameData, ...rest })=>{
                const initialGameData = gameData ? {
                    points: 0,
                    assists: 0,
                    rebounds: 0,
                    steals: 0,
                    blocks: 0
                } : undefined;
                return {
                    ...rest,
                    gameData: initialGameData
                };
            });
            this.init({
                updateYaxis: true
            });
            const lastDataIndex = this.data.findIndex((_, index)=>!this.data[index + 1]?.gameData);
            this.currentHoverIndex = lastDataIndex;
            if (data.length) requestAnimationFrame(()=>{
                this.data = data;
                this.setAxisLabels({
                    isUpdateXaxis: true,
                    isUpdateYaxis: true
                });
                this.updateChartPoints();
            });
        };
        this.setDataKey = (dataKey)=>{
            if (this.currDataKey === dataKey) return;
            this.currDataKey = dataKey;
            this.setAxisLabels({
                isUpdateYaxis: true
            });
            this.updateChartPoints();
        };
        this.lineChartContainer = container;
        this.data = data;
        this.currDataKey = dataKey || "points";
        this.dataKeyAbbreviation = dataKeyAbbreviation;
        this.onChartContainerScroll = onChartContainerScroll;
        const lineChartTemplate = document.querySelector("#stats-line-chart");
        this.lineChart = lineChartTemplate.content.cloneNode(true).children[0];
        this.tooltip = this.lineChart.querySelector("#stats-line-chart-tooltip");
        this.lineChartContainerResizeObserver = new ResizeObserver(this.onContainerResize);
        this.init({});
    }
    destroy() {
        this.lineChartContainerResizeObserver.disconnect();
    }
}


class $5df4dfa5f3f68682$export$fd727f3af6222cfc {
    constructor(canvasElement, useRaf){
        this.dpr = window.devicePixelRatio || 1;
        this.resizeCanvas = ()=>{
            this.ctx.canvas.width = this.canvas.clientWidth * this.dpr;
            this.ctx.canvas.height = this.canvas.clientHeight * this.dpr;
            if (this.mediaElement && !this.useRaf) this.drawElement(this.mediaElement);
        };
        this.setElement = (mediaElement)=>{
            this.mediaElement = mediaElement;
            if (!this.useRaf) this.drawElement(mediaElement);
        };
        this.drawElement = (mediaElement)=>{
            const elementWidth = mediaElement instanceof HTMLVideoElement ? mediaElement.videoWidth : mediaElement.naturalWidth;
            const elementHeight = mediaElement instanceof HTMLVideoElement ? mediaElement.videoHeight : mediaElement.naturalHeight;
            const canvasRatio = this.ctx.canvas.width / this.ctx.canvas.height;
            const mediaRatio = elementWidth / elementHeight;
            let drawWidth, drawHeight, offsetX, offsetY;
            if (mediaRatio > canvasRatio) {
                // wider — crop left/right
                drawHeight = this.ctx.canvas.height;
                drawWidth = elementWidth * (this.ctx.canvas.height / elementHeight);
                offsetX = (this.ctx.canvas.width - drawWidth) / 2;
                offsetY = 0;
            } else {
                // taller — crop top/bottom
                drawWidth = this.ctx.canvas.width;
                drawHeight = elementHeight * (this.ctx.canvas.width / elementWidth);
                offsetX = 0;
                offsetY = (this.ctx.canvas.height - drawHeight) / 2;
            }
            this.ctx.drawImage(mediaElement, offsetX, offsetY, drawWidth, drawHeight);
        };
        this.clear = ()=>{
            this.ctx.clearRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height);
        };
        this.rafUpdate = ()=>{
            if (this.mediaElement) this.drawElement(this.mediaElement);
            if (this.useRaf) requestAnimationFrame(this.rafUpdate);
        };
        this.canvas = canvasElement;
        this.ctx = this.canvas.getContext("2d");
        this.useRaf = useRaf;
        const resizeObserver = new ResizeObserver(this.resizeCanvas);
        resizeObserver.observe(this.canvas);
        if (this.useRaf) requestAnimationFrame(this.rafUpdate);
    }
}



const $35a83204df8e8a21$var$SORT_KEYS = [
    "points",
    "assists",
    "rebounds",
    "steals",
    "blocks"
];
const $35a83204df8e8a21$var$PLAYER_DASHBOARD_MARGIN_TOP = 24;
const $35a83204df8e8a21$var$BASE_DASHBOARD_MODAL_TRANSITION_DURATION = 400;
const $35a83204df8e8a21$var$BASE_DASHBOARD_MODAL_ROW_TOP = 440;
const $35a83204df8e8a21$var$LINE_UP_VIDEO_CONTAINER_WRAPPER_TRANSLATE_Y_ANIMATION_DURATION = 300;
const $35a83204df8e8a21$var$MOBILE_BACKGROUND_ASSETS_MAX_WIDTH = 640;
class $35a83204df8e8a21$export$56b534bd20b9e350 {
    constructor(props){
        this.sortedPlayers = [];
        this.sortKey = "points";
        this.preventDashboardLenisScroll = false;
        this.forceDashboardLenisScroll = false;
        this.tableColumnHeaders = [];
        this.sortButtons = [];
        this.lineUpVideoContainerWrapperTranslateY = 0;
        this.activePlayerDashboardTranslateY = 0;
        this.playerBackgroundImageData = {};
        this.mobilePlayerBackgroundImageData = {};
        this.playerBackgroundVideoData = {};
        this.mobilePlayerBackgroundVideoData = {};
        this.defaultBackgroundVideosLength = 0;
        this.useMobileBackgroundAssets = window.innerWidth <= $35a83204df8e8a21$var$MOBILE_BACKGROUND_ASSETS_MAX_WIDTH;
        this.playerDashboardContentTemplateData = {};
        this.updatingTableRows = false;
        this.isPlayerDashboardActive = false;
        this.isPlayerDashboardRendered = false;
        this.scrollbarWidth = 0;
        this.isMobile = (0, $33b2d2d40c177c1d$export$d0a8044dce8ff2fc)();
        this.mobileVideoLoadTest = (0, $e11d3b47fe7a2d7b$export$4eb74929f54da8ee)();
        this.prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        this.onBodyResize = ()=>{
            if (!this.isPlayerDashboardActive) this.scrollbarWidth = window.innerWidth - document.body.clientWidth;
        };
        this.onPlayerDashboardResize = ()=>{
            if (this.isPlayerDashboardActive) {
                const playerDashboard = document.querySelector(".player-dashboard");
                this.scrollbarWidth = playerDashboard.offsetWidth - playerDashboard.clientWidth;
                this.pageMain.style.setProperty("--content-padding-right-offset", `${this.scrollbarWidth}px`);
            }
        };
        this.onTableRowsUpdateComplete = ()=>{
            Array.from(this.tableBody.children).forEach((tableRow)=>{
                const dataCells = tableRow.querySelectorAll("[role='cell']:not(:first-child)");
                dataCells[0].style.removeProperty("max-height");
                dataCells[0].style.removeProperty("grid-template-rows");
                dataCells.forEach((cell)=>{
                    cell.children[0].remove();
                });
            });
            this.tableBody.classList.remove("homepage-lineup-table-body--updating");
            this.updatingTableRows = false;
        };
        this.onPlayerRowClick = (row)=>{
            if (!this.isPlayerDashboardActive) {
                const playerId = row.getAttribute("data-player-id");
                if (playerId) this.openPlayerDashboard(row, playerId);
                row.blur();
            }
        };
        this.onPlayerRowPointerOver = (row)=>{
            const playerId = row.getAttribute("data-player-id");
            const playerIndex = this.sortedPlayers.findIndex((player)=>player.id === playerId);
            if (playerId && playerIndex >= 0) this.updateActiveHoverTableRow({
                id: playerId,
                index: playerIndex
            });
        };
        this.getRowFade = (index, activeIndex)=>{
            if (index === activeIndex) return {
                opacity: 1,
                blur: 0
            };
            if (Math.abs(index - activeIndex) === 1) return {
                opacity: 0.4,
                blur: 1
            };
            if (Math.abs(index - activeIndex) === 2) return {
                opacity: 0.24,
                blur: 1.5
            };
            return {
                opacity: 0.12,
                blur: 2
            };
        };
        this.updateActiveHoverTableRow = ({ id: id, index: index, noDelay: noDelay, isMobileScrollTriggered: isMobileScrollTriggered, forceUpdate: forceUpdate })=>{
            if (this.hoveredTableRowPlayerId === id && !forceUpdate) return;
            const isForcedUpdate = this.hoveredTableRowPlayerId === id;
            if (this.updateActivePlayerBackgroundVideoTimeout) clearTimeout(this.updateActivePlayerBackgroundVideoTimeout);
            if (this.mobilePlayVideoTimeout) clearTimeout(this.mobilePlayVideoTimeout);
            Array.from(this.tableBody.children).forEach((row, rowIndex)=>{
                row.classList.toggle("homepage-lineup-table-row--hovered", rowIndex === index);
                const getRowFade = this.getRowFade(rowIndex, index);
                row.style.setProperty("--fade-opacity", getRowFade.opacity.toString());
                row.style.setProperty("--fade-blur", `${getRowFade.blur}px`);
            });
            const mobileDelay = isMobileScrollTriggered ? 800 : 100;
            const delayDuration = this.mobileVideoLoadTest ? 0 : this.isMobile ? mobileDelay : 100;
            const timeoutDuration = noDelay || !this.hoveredTableRowPlayerId ? 0 : delayDuration;
            this.hoveredTableRowPlayerId = id;
            if (this.isMobile) this.lineUpVideoCanvas.style.setProperty("opacity", "0");
            this.updateActivePlayerBackgroundVideoTimeout = setTimeout(()=>{
                if (!this.isMobile) this.lineUpVideoCanvas.style.setProperty("opacity", "0");
                const backgroundImageElement = this.useMobileBackgroundAssets ? this.mobilePlayerBackgroundImageData[id] || this.playerBackgroundImageData[id] : this.playerBackgroundImageData[id];
                this.canvasBackgroundImage.setElement(backgroundImageElement);
                const renderMobileVideo = this.useMobileBackgroundAssets && Boolean(this.mobilePlayerBackgroundVideoData[id]);
                const backgroundVideoDataEntries = [
                    ...Object.entries(this.playerBackgroundVideoData),
                    ...Object.entries(this.mobilePlayerBackgroundVideoData)
                ];
                backgroundVideoDataEntries.forEach(([id, video], index)=>{
                    const isMobileVideoData = index >= this.defaultBackgroundVideosLength;
                    const isPlayerVideo = renderMobileVideo ? isMobileVideoData && id === this.hoveredTableRowPlayerId : !isMobileVideoData && id === this.hoveredTableRowPlayerId;
                    if (video && !isPlayerVideo && !video.paused) {
                        video.pause();
                        video.currentTime = 0;
                    }
                    if (video && isPlayerVideo) {
                        if (!isForcedUpdate) video.currentTime = 0;
                        this.canvasBackgroundVideo.setElement(video);
                        this.canvasBackgroundVideo.clear();
                        if (this.isMobile && !this.mobileVideoLoadTest) this.mobilePlayVideoTimeout = setTimeout(()=>{
                            video.play();
                            this.lineUpVideoCanvas.style.removeProperty("opacity");
                        }, 800);
                        else {
                            video.play();
                            this.lineUpVideoCanvas.style.removeProperty("opacity");
                        }
                    }
                });
            }, timeoutDuration);
        };
        this.openPlayerDashboard = (row, id, isPageLoad)=>{
            if (this.lenis) this.lenis.stop();
            this.isPlayerDashboardActive = true;
            document.body.style.setProperty("overflow", "hidden");
            this.pageMain.style.setProperty("--content-padding-right-offset", `${this.scrollbarWidth}px`);
            this.otherPageMainSections.forEach((section)=>{
                section.classList.add("homepage-section--overlayed");
            });
            const rowTop = row.getBoundingClientRect().top - $35a83204df8e8a21$var$PLAYER_DASHBOARD_MARGIN_TOP;
            const animationDurationMultiplier = rowTop < $35a83204df8e8a21$var$BASE_DASHBOARD_MODAL_ROW_TOP ? 0.15 : 0.3;
            const animationDuration = (rowTop - $35a83204df8e8a21$var$BASE_DASHBOARD_MODAL_ROW_TOP) * animationDurationMultiplier + $35a83204df8e8a21$var$BASE_DASHBOARD_MODAL_TRANSITION_DURATION;
            this.pageMain.style.setProperty("--lineup-player-row-animation-duration", `${animationDuration}ms`);
            this.pageMain.style.setProperty("--lineup-player-row-offset", `${-rowTop}px`);
            const postActiveRowTop = Math.max(Math.abs(rowTop), 150);
            this.pageMain.style.setProperty("--lineup-player-post-active-row-offset", `${postActiveRowTop}px`);
            this.lineUpSection.classList.add("homepage-section--lineup-overlayed");
            row.classList.add("homepage-lineup-table-row--active-overlay-row");
            row.classList.add("homepage-lineup-table-row--active-overlay-transition");
            const playerDashboardTemplate = this.playerDashboardTemplate.content.cloneNode(true);
            const playerDashboard = playerDashboardTemplate.children[0];
            this.pageMain.appendChild(playerDashboard);
            const closeButton = playerDashboard.querySelector("[data-player-dashboard-close-button]");
            closeButton.addEventListener("click", this.closePlayerDashboard);
            this.playerDashboardResizeObserver.observe(playerDashboard);
            this.renderPlayerDashboard({
                playerDashboard: playerDashboard,
                row: row,
                id: id,
                isPageLoad: isPageLoad
            });
            this.isPlayerDashboardRendered = true;
        };
        this.renderNextPlayerDashboard = (playerDashboard, nextPlayerIndex)=>{
            const playerData = this.sortedPlayers[nextPlayerIndex];
            const playerTableRow = this.tableBody.children[nextPlayerIndex];
            const playerDashboardContent = playerDashboard.querySelector("#player-dashboard-content");
            const [_, header, playerTicket, currentBody, nextHeader] = playerDashboardContent.children;
            this.playerDashboardHeaderResizeObserver?.disconnect();
            header.style.setProperty("transition", "none");
            header.style.setProperty("opacity", "0");
            playerTicket.style.setProperty("transition", "none");
            playerTicket.style.setProperty("opacity", "0");
            const nextPlayerHeaderNameEl = playerDashboard.querySelector("[data-player-dashboard-header-name][tabindex]");
            nextPlayerHeaderNameEl.removeAttribute("tabindex");
            playerDashboardContent.appendChild(nextHeader.cloneNode(true));
            this.updateActiveHoverTableRow({
                id: playerData.id,
                index: nextPlayerIndex,
                noDelay: true
            });
            const currentOverlayRow = this.tableBody.querySelector(".homepage-lineup-table-row--active-overlay-row");
            currentOverlayRow.style.setProperty("transition", "none");
            currentOverlayRow.classList.remove("homepage-lineup-table-row--active-overlay-row");
            currentOverlayRow.classList.remove("homepage-lineup-table-row--active-overlay-transition");
            playerTableRow.style.setProperty("transition", "none");
            const playerRowCells = playerTableRow.querySelectorAll("[role='cell']");
            playerRowCells.forEach((cell)=>{
                cell.style.setProperty("transition", "none");
            });
            playerTableRow.classList.add("homepage-lineup-table-row--active-overlay-row");
            playerTableRow.classList.add("homepage-lineup-table-row--active-overlay-transition");
            const rowTop = playerTableRow.getBoundingClientRect().top - $35a83204df8e8a21$var$PLAYER_DASHBOARD_MARGIN_TOP;
            const animationDurationMultiplier = rowTop < $35a83204df8e8a21$var$BASE_DASHBOARD_MODAL_ROW_TOP ? 0.15 : 0.3;
            const animationDuration = (rowTop - $35a83204df8e8a21$var$BASE_DASHBOARD_MODAL_ROW_TOP) * animationDurationMultiplier + $35a83204df8e8a21$var$BASE_DASHBOARD_MODAL_TRANSITION_DURATION;
            this.pageMain.style.setProperty("--lineup-player-row-animation-duration", `${animationDuration}ms`);
            // update window scroll to align background table row with header title
            // This also ensures that the dashboard header transforms to the player row position when closed
            window.scrollTo({
                top: rowTop + window.scrollY
            });
            this.renderPlayerDashboard({
                playerDashboard: playerDashboard,
                row: playerTableRow,
                id: playerData.id,
                isRenderNext: true
            });
            currentOverlayRow.style.removeProperty("transition");
            playerTableRow.style.removeProperty("transition");
            playerRowCells.forEach((cell)=>{
                cell.style.removeProperty("transition");
            });
            this.lineUpVideoContainerWrapper.style.setProperty("transition", "none");
            // reset lineup video container wrapper translate Y to fix iOS offset bug
            this.lineUpVideoContainerWrapperTranslateYAnimationStartAt = performance.now();
            requestAnimationFrame(this.animateLineUpVideoContainerWrapperTranslateY);
            this.forceDashboardLenisScroll = true;
            if (!this.lenis) // temporary lenis instance to efficiently remove previous dashboard content and scroll to top
            this.dashboardLenis = new (0, $8ecb29f509dc0bd0$export$2e2bcd8739ae039)({
                wrapper: playerDashboard,
                content: playerDashboardContent,
                autoRaf: true
            });
            this.dashboardLenis?.scrollTo(nextPlayerHeaderNameEl.parentElement, {
                offset: 0,
                lock: true,
                immediate: this.prefersReducedMotion,
                duration: 0.8,
                // ease out cubic
                easing: (t)=>1 - Math.pow(1 - t, 3),
                onComplete: ()=>{
                    header.remove();
                    playerTicket.remove();
                    currentBody.remove();
                    playerDashboard.scrollTop = 0;
                    this.forceDashboardLenisScroll = false;
                    if (!this.lenis) {
                        // remove after scroll to top if no main lenis instance
                        this.dashboardLenis?.destroy();
                        this.dashboardLenis = undefined;
                    }
                    this.lineUpVideoContainerWrapper.style.removeProperty("transition");
                    // iOS Chrome occasionally renders dashboard below top 0 when the browser's URL bar is in compact mode
                    const dashboardTop = playerDashboard.getBoundingClientRect().top;
                    if (dashboardTop !== 0) {
                        this.activePlayerDashboardTranslateY -= dashboardTop;
                        playerDashboard.style.setProperty("transform", `translateY(${this.activePlayerDashboardTranslateY}px)`);
                    }
                }
            });
        };
        this.animateLineUpVideoContainerWrapperTranslateY = (timestamp)=>{
            if (!this.lineUpVideoContainerWrapperTranslateYAnimationStartAt || timestamp - this.lineUpVideoContainerWrapperTranslateYAnimationStartAt > $35a83204df8e8a21$var$LINE_UP_VIDEO_CONTAINER_WRAPPER_TRANSLATE_Y_ANIMATION_DURATION) return;
            this.lineUpVideoContainerWrapperTranslateY -= this.lineUpVideoContainerWrapper.getBoundingClientRect().top;
            this.lineUpVideoContainerWrapper.style.setProperty("transform", `translateY(${this.lineUpVideoContainerWrapperTranslateY}px)`);
            requestAnimationFrame(this.animateLineUpVideoContainerWrapperTranslateY);
        };
        this.closePlayerDashboard = ()=>{
            if (location.hash) {
                if (history.state && history.state.modalId) history.go(-1);
                else history.pushState(null, "", location.pathname);
            }
            const playerDashboard = document.querySelector(".player-dashboard");
            this.playerDashboardResizeObserver.unobserve(playerDashboard);
            this.isPlayerDashboardActive = false;
            this.isPlayerDashboardRendered = false;
            this.dashboardLenis?.stop();
            this.lineUpVideoContainerWrapperTranslateY = 0;
            this.activePlayerDashboardTranslateY = 0;
            playerDashboard.style.removeProperty("transform");
            this.lineUpVideoContainerWrapper.style.setProperty("transform", "translateY(0px)");
            this.otherPageMainSections.forEach((section)=>{
                section.classList.remove("homepage-section--overlayed");
            });
            this.lineUpSection.classList.remove("homepage-section--lineup-overlayed");
            const activeRow = this.tableBody.querySelector(".homepage-lineup-table-row--active-overlay-row");
            activeRow?.classList.remove("homepage-lineup-table-row--active-overlay-row");
            const closeButton = playerDashboard.querySelector("[data-player-dashboard-close-button]");
            closeButton.addEventListener("transitionend", ()=>{
                const activeRowCells = activeRow.querySelectorAll("[role='cell']");
                activeRowCells[0].style.setProperty("transition", "none");
                activeRowCells[1].style.setProperty("transition", "none");
                setTimeout(()=>{
                    activeRowCells[0].style.removeProperty("transition");
                    activeRowCells[1].style.removeProperty("transition");
                }, 100);
                activeRow.classList.remove("homepage-lineup-table-row--active-overlay-transition");
                playerDashboard.remove();
                if (this.lenis) {
                    this.lenis.start();
                    this.dashboardLenis?.destroy();
                    this.dashboardLenis = undefined;
                }
                document.body.style.removeProperty("overflow");
                this.pageMain.style.removeProperty("--content-padding-right-offset");
                history.scrollRestoration = "auto";
            }, {
                once: true
            });
            playerDashboard.classList.remove("player-dashboard--active");
        };
        this.onWindowHashChange = (e)=>{
            const oldHash = new URL(e.oldURL).hash.replace("#", "");
            const newHash = new URL(e.newURL).hash.replace("#", "");
            const newHashPlayerIndex = this.sortedPlayers.findIndex((player)=>player.id === newHash);
            if (this.isPlayerDashboardActive && newHashPlayerIndex < 0 && oldHash === this.activePlayerDashboardId) this.closePlayerDashboard();
            else if (!this.isPlayerDashboardActive && newHash) {
                if (newHashPlayerIndex === -1) return;
                this.openPlayerDashboard(this.tableBody.children[newHashPlayerIndex], newHash);
            }
        };
        this.onMobileWindowScroll = ()=>{
            if (this.isPlayerDashboardActive) return;
            const activeRowIndex = Array.from(this.tableBody.children).findLastIndex((child)=>{
                const { top: top, height: height } = child.getBoundingClientRect();
                return window.innerHeight / 2 > top + height / 2;
            });
            if (activeRowIndex !== -1) {
                const activePlayerId = this.sortedPlayers[activeRowIndex].id;
                this.updateActiveHoverTableRow({
                    id: activePlayerId,
                    index: activeRowIndex,
                    isMobileScrollTriggered: true
                });
            }
        };
        this.onStatsChartContainerScroll = ()=>{
            if (this.dashboardLenis) {
                this.preventDashboardLenisScroll = true;
                clearTimeout(this.returnDashboardLenisScrollTimeoutId);
                this.returnDashboardLenisScrollTimeoutId = setTimeout(()=>{
                    this.preventDashboardLenisScroll = false;
                }, 100);
            }
        };
        this.onWindowResize = ()=>{
            const useMobileBackgroundAssets = window.innerWidth <= $35a83204df8e8a21$var$MOBILE_BACKGROUND_ASSETS_MAX_WIDTH;
            if (useMobileBackgroundAssets !== this.useMobileBackgroundAssets) {
                this.useMobileBackgroundAssets = useMobileBackgroundAssets;
                if (this.hoveredTableRowPlayerId) this.updateActiveHoverTableRow({
                    id: this.hoveredTableRowPlayerId,
                    index: this.sortedPlayers.findIndex((player)=>player.id === this.hoveredTableRowPlayerId),
                    noDelay: true,
                    forceUpdate: true
                });
            }
        };
        this.resizeSelectToFitContent = (select)=>{
            const tempOptionContainer = document.createElement("span");
            tempOptionContainer.textContent = select.options[select.selectedIndex].textContent;
            tempOptionContainer.style.visibility = "hidden";
            tempOptionContainer.style.whiteSpace = "pre";
            tempOptionContainer.style.position = "absolute";
            const { font: font, letterSpacing: letterSpacing, textTransform: textTransform } = getComputedStyle(select);
            tempOptionContainer.style.font = font;
            tempOptionContainer.style.letterSpacing = letterSpacing;
            tempOptionContainer.style.textTransform = textTransform;
            document.body.appendChild(tempOptionContainer);
            const selectWidth = tempOptionContainer.offsetWidth + 32;
            select.style.setProperty("width", `${selectWidth}px`);
            document.body.removeChild(tempOptionContainer);
        };
        this.getAverageFromLineChartData = (data, dataKey)=>{
            const totalGamesWithData = data.filter((entry)=>Boolean(entry.gameData)).length;
            if (!totalGamesWithData) return "0.0";
            const total = data.reduce((sum, entry)=>sum + Number(entry.gameData?.[dataKey] || 0), 0);
            const average = total / totalGamesWithData;
            return average.toFixed(1);
        };
        this.updateStatsFilterButtonValue = (button, value)=>{
            const buttonValueElement = button.querySelector("[stats-perf-button-value]");
            const prevValueTextElement = Array.from(buttonValueElement.children).at(-1);
            const nextValueTextElement = prevValueTextElement.cloneNode(true);
            nextValueTextElement.textContent = value;
            buttonValueElement.innerHTML = "";
            buttonValueElement.appendChild(prevValueTextElement);
            buttonValueElement.appendChild(nextValueTextElement);
            prevValueTextElement.addEventListener("transitionend", ()=>{
                prevValueTextElement.remove();
            });
            buttonValueElement.classList.add("player-dashboard-player-stats-perf-button__value--updating");
            requestAnimationFrame(()=>{
                buttonValueElement.classList.remove("player-dashboard-player-stats-perf-button__value--updating");
            });
        };
        this.setTicketClipPath = (ticketElement)=>{
            const { width: ticketWidth, height: ticketHeight } = ticketElement.getBoundingClientRect();
            const { width: columnOneWidth, height: columnOneHeight } = ticketElement.querySelectorAll("[data-ticket-column]")[0].getBoundingClientRect();
            const { width: columnTwoWidth, height: columnTwoHeight } = ticketElement.querySelectorAll("[data-ticket-column]")[1].getBoundingClientRect();
            const clipPath = window.innerWidth > 900 ? (0, $2a8d297402734a47$export$4064ccfd0479f329)({
                height: ticketHeight,
                columnOneWidth: columnOneWidth,
                columnTwoWidth: columnTwoWidth,
                gap: 10,
                gapInset: 10,
                radius: 2
            }) : (0, $2a8d297402734a47$export$c435da95ea8cb26)({
                width: ticketWidth,
                columnOneHeight: columnOneHeight,
                columnTwoHeight: columnTwoHeight,
                gap: 10,
                gapInset: 9,
                radius: 2
            });
            ticketElement.style.setProperty("--ticket-clip-path", `path("${clipPath}")`);
        };
        this.addPlayersDashboardContentTemplate = ()=>{
            this.players.forEach((player)=>{
                const playerDashboardContentTemplate = document.querySelector(`#player-dashboard-content-${player.id}`);
                if (playerDashboardContentTemplate) this.playerDashboardContentTemplateData[player.id] = playerDashboardContentTemplate;
                else console.log(`NO PLAYER DASHBOARD CONTENT TEMPLATE FOR: ${player.id}`);
            });
            this.players = this.players.filter((player)=>this.playerDashboardContentTemplateData[player.id]);
        };
        this.addPlayersBackgroundVideoElements = ()=>{
            let defaultBackgroundVideosLength = 0;
            this.players.forEach((player)=>{
                const imageElement = document.createElement("img");
                imageElement.src = player.imageUrl;
                this.playerBackgroundImageData[player.id] = imageElement;
                if (player.mobileImageUrl) {
                    const mobileImageElement = document.createElement("img");
                    mobileImageElement.src = player.mobileImageUrl;
                    this.mobilePlayerBackgroundImageData[player.id] = mobileImageElement;
                }
                if (player.videoUrl) {
                    const videoElement = document.createElement("video");
                    videoElement.src = player.videoUrl;
                    videoElement.poster = player.imageUrl;
                    videoElement.muted = true;
                    videoElement.loop = true;
                    videoElement.playsInline = true;
                    videoElement.preload = this.mobileVideoLoadTest ? "auto" : "none";
                    if (this.mobileVideoLoadTest) videoElement.load();
                    this.playerBackgroundVideoData[player.id] = videoElement;
                    defaultBackgroundVideosLength++;
                }
                if (player.mobileVideoUrl) {
                    const mobileVideoElement = document.createElement("video");
                    mobileVideoElement.src = player.mobileVideoUrl;
                    mobileVideoElement.poster = player.mobileImageUrl || player.imageUrl;
                    mobileVideoElement.muted = true;
                    mobileVideoElement.loop = true;
                    mobileVideoElement.playsInline = true;
                    mobileVideoElement.preload = this.mobileVideoLoadTest ? "auto" : "none";
                    if (this.mobileVideoLoadTest) mobileVideoElement.load();
                    this.mobilePlayerBackgroundVideoData[player.id] = mobileVideoElement;
                }
            });
            this.defaultBackgroundVideosLength = defaultBackgroundVideosLength;
        };
        this.lenis = props.lenis;
        this.players = props.players;
        this.dataKeyAbbreviation = props.dataKeyAbbreviation;
        this.tableRowTemplate = document.querySelector("#lineup-table-row");
        this.playerDashboardTemplate = document.querySelector("#player-dashboard");
        this.lineUpVideoContainerWrapper = document.querySelector("#lineup-video-container-wrapper");
        this.lineUpVideoContainer = document.querySelector("#lineup-video-container");
        this.lineUpVideoBackgroundItems = document.querySelector("#lineup-video-background-items");
        this.tableBody = document.querySelector("#lineup-table-body");
        this.pageMain = document.querySelector("#homepage-main");
        this.otherPageMainSections = Array.from(document.querySelectorAll("#homepage-main > section:not([id='lineup']), #homepage-main > footer"));
        this.canvasBackgroundImage = new (0, $5df4dfa5f3f68682$export$fd727f3af6222cfc)(document.querySelector("#lineup-background-image-canvas"));
        this.lineUpVideoCanvas = document.querySelector("#lineup-background-video-canvas");
        this.canvasBackgroundVideo = new (0, $5df4dfa5f3f68682$export$fd727f3af6222cfc)(this.lineUpVideoCanvas, true);
        this.lineUpSection = document.querySelector("#lineup");
        this.bodyResizeObserver = new ResizeObserver(this.onBodyResize);
        this.bodyResizeObserver.observe(document.body);
        this.playerDashboardResizeObserver = new ResizeObserver(this.onPlayerDashboardResize);
        this.init();
        window.addEventListener("resize", this.onWindowResize);
    }
    init() {
        this.addPlayersDashboardContentTemplate();
        this.tableColumnHeaders = Array.from(document.querySelectorAll("#lineup-table-header [role='columnheader']:not([aria-sort='none'])"));
        this.sortButtons = Array.from(document.querySelectorAll("#lineup-table-header button"));
        this.sortButtons.forEach((button, index)=>{
            button.addEventListener("click", ()=>{
                if (this.updatingTableRows) return;
                if (this.sortKey === $35a83204df8e8a21$var$SORT_KEYS[index]) return;
                this.sortKey = $35a83204df8e8a21$var$SORT_KEYS[index];
                button.setAttribute("aria-pressed", "true");
                this.sortPlayers();
                this.updateTableRows();
                if (this.hoveredTableRowPlayerId) {
                    this.hoveredTableRowPlayerId = undefined;
                    const hoveredTableRowPlayerId = this.sortedPlayers[0].id;
                    this.updateActiveHoverTableRow({
                        id: hoveredTableRowPlayerId,
                        index: 0
                    });
                }
            });
        });
        this.sortPlayers();
        this.renderTableRows();
        this.addPlayersBackgroundVideoElements();
        window.addEventListener("keydown", (e)=>{
            if (e.key === "Escape" && this.isPlayerDashboardRendered) {
                e.preventDefault();
                this.closePlayerDashboard();
            }
        });
        window.addEventListener("hashchange", this.onWindowHashChange);
        if (location.hash) {
            const hash = location.hash.replace("#", "");
            const playerIndex = this.sortedPlayers.findIndex((player)=>player.id === hash);
            if (playerIndex >= 0) {
                const playerTableRow = this.tableBody.children[playerIndex];
                playerTableRow.scrollIntoView({
                    block: "center"
                });
                this.updateActiveHoverTableRow({
                    id: hash,
                    index: playerIndex,
                    noDelay: true
                });
                this.openPlayerDashboard(this.tableBody.children[playerIndex], hash, true);
            }
        }
        document.body.addEventListener("loader-25:loader-exited", ()=>{
            if (this.isPlayerDashboardActive) document.body.style.setProperty("overflow", "hidden");
        });
    }
    sortPlayers() {
        this.sortedPlayers = [
            ...this.players
        ].sort((a, b)=>b[this.sortKey] - a[this.sortKey]);
        this.tableColumnHeaders.forEach((header)=>{
            header.removeAttribute("aria-sort");
        });
        const sortKeyIndex = $35a83204df8e8a21$var$SORT_KEYS.indexOf(this.sortKey);
        this.tableColumnHeaders[sortKeyIndex].setAttribute("aria-sort", "descending");
        this.sortButtons.forEach((button, index)=>{
            if (index !== sortKeyIndex) button.removeAttribute("aria-pressed");
        });
        if (this.isMobile) window.addEventListener("scroll", this.onMobileWindowScroll, {
            passive: true
        });
    }
    renderTableRows() {
        this.tableBody.innerHTML = "";
        this.sortedPlayers.forEach((player, index)=>{
            const tableRowTemplate = this.tableRowTemplate.content.cloneNode(true);
            const tableRow = tableRowTemplate.children[0];
            tableRow.setAttribute("data-player-id", player.id);
            tableRow.addEventListener("click", ()=>this.onPlayerRowClick(tableRow));
            tableRow.addEventListener("keydown", (e)=>{
                if (e.key === "Enter" || e.key === " ") this.onPlayerRowClick(tableRow);
            });
            tableRow.addEventListener("pointerover", ()=>this.onPlayerRowPointerOver(tableRow));
            // add move for more stability when scrolling
            tableRow.addEventListener("pointermove", ()=>this.onPlayerRowPointerOver(tableRow));
            tableRow.addEventListener("focus", ()=>this.onPlayerRowPointerOver(tableRow));
            const cells = tableRow.querySelectorAll("[role='cell']");
            cells[0].children[0].appendChild(document.createTextNode((index + 1).toString()));
            if (player.lastName.includes("-")) cells[1].firstChild.firstChild.textContent = ` ${player.firstName} ${player.lastName}`;
            else {
                cells[1].firstChild.firstChild.textContent = player.firstName;
                cells[1].firstChild.firstChild.appendChild(document.createElement("br"));
                cells[1].firstChild.firstChild.appendChild(document.createTextNode(player.lastName));
            }
            cells[1].firstChild.childNodes[1].textContent = `[${player.number}]`;
            cells[2].firstChild.textContent = (0, $07d93c758297752a$export$b1a1fb9a3c566543)(player.points);
            cells[2].classList.toggle("homepage-lineup-table-sorted", this.sortKey === "points");
            cells[2].firstChild.classList.toggle("homepage-lineup-table-item--sorted", this.sortKey === "points");
            cells[3].firstChild.textContent = (0, $07d93c758297752a$export$b1a1fb9a3c566543)(player.assists);
            cells[3].classList.toggle("homepage-lineup-table-sorted", this.sortKey === "assists");
            cells[3].firstChild.classList.toggle("homepage-lineup-table-item--sorted", this.sortKey === "assists");
            cells[4].firstChild.textContent = (0, $07d93c758297752a$export$b1a1fb9a3c566543)(player.rebounds);
            cells[4].classList.toggle("homepage-lineup-table-sorted", this.sortKey === "rebounds");
            cells[4].firstChild.classList.toggle("homepage-lineup-table-item--sorted", this.sortKey === "rebounds");
            cells[5].firstChild.textContent = (0, $07d93c758297752a$export$b1a1fb9a3c566543)(player.steals);
            cells[5].classList.toggle("homepage-lineup-table-sorted", this.sortKey === "steals");
            cells[5].firstChild.classList.toggle("homepage-lineup-table-item--sorted", this.sortKey === "steals");
            cells[6].firstChild.textContent = (0, $07d93c758297752a$export$b1a1fb9a3c566543)(player.blocks);
            cells[6].classList.toggle("homepage-lineup-table-sorted", this.sortKey === "blocks");
            cells[6].firstChild.classList.toggle("homepage-lineup-table-item--sorted", this.sortKey === "blocks");
            this.tableBody.appendChild(tableRow);
        });
    }
    updateTableRows() {
        this.updatingTableRows = true;
        const isCompactTable = window.innerWidth <= 1140;
        this.sortedPlayers.forEach((player, index)=>{
            const tableRow = this.tableBody.children[index];
            tableRow.setAttribute("data-player-id", player.id);
            const cells = tableRow.querySelectorAll("[role='cell']");
            if (isCompactTable) {
                // to ensure the visible cell is animating from the previous sorted stat value
                const currentSortedCellSpan = tableRow.querySelector(".homepage-lineup-table-item--sorted");
                cells[2].innerHTML = currentSortedCellSpan.outerHTML;
                cells[3].innerHTML = currentSortedCellSpan.outerHTML;
                cells[4].innerHTML = currentSortedCellSpan.outerHTML;
                cells[5].innerHTML = currentSortedCellSpan.outerHTML;
                cells[6].innerHTML = currentSortedCellSpan.outerHTML;
            }
            const nameElement = cells[1].firstChild?.cloneNode(true);
            if (player.lastName.includes("-")) nameElement.firstChild.textContent = ` ${player.firstName} ${player.lastName}`;
            else {
                nameElement.firstChild.textContent = player.firstName;
                nameElement.firstChild.appendChild(document.createElement("br"));
                nameElement.firstChild.appendChild(document.createTextNode(player.lastName));
            }
            nameElement.childNodes[1].textContent = `[${player.number}]`;
            cells[1].style.setProperty("max-height", `${cells[1].getBoundingClientRect().height}px`);
            cells[1].appendChild(nameElement);
            const pointsElement = cells[2].firstChild?.cloneNode(true);
            pointsElement.textContent = (0, $07d93c758297752a$export$b1a1fb9a3c566543)(player.points);
            pointsElement.classList.toggle("homepage-lineup-table-item--sorted", this.sortKey === "points");
            cells[2].appendChild(pointsElement);
            cells[2].classList.toggle("homepage-lineup-table-sorted", this.sortKey === "points");
            const assistsElement = cells[3].firstChild?.cloneNode(true);
            assistsElement.textContent = (0, $07d93c758297752a$export$b1a1fb9a3c566543)(player.assists);
            assistsElement.classList.toggle("homepage-lineup-table-item--sorted", this.sortKey === "assists");
            cells[3].classList.toggle("homepage-lineup-table-sorted", this.sortKey === "assists");
            cells[3].appendChild(assistsElement);
            const reboundsElement = cells[4].firstChild?.cloneNode(true);
            reboundsElement.textContent = (0, $07d93c758297752a$export$b1a1fb9a3c566543)(player.rebounds);
            reboundsElement.classList.toggle("homepage-lineup-table-item--sorted", this.sortKey === "rebounds");
            cells[4].classList.toggle("homepage-lineup-table-sorted", this.sortKey === "rebounds");
            cells[4].appendChild(reboundsElement);
            const stealsElement = cells[5].firstChild?.cloneNode(true);
            stealsElement.textContent = (0, $07d93c758297752a$export$b1a1fb9a3c566543)(player.steals);
            stealsElement.classList.toggle("homepage-lineup-table-item--sorted", this.sortKey === "steals");
            cells[5].classList.toggle("homepage-lineup-table-sorted", this.sortKey === "steals");
            cells[5].appendChild(stealsElement);
            const blocksElement = cells[6].firstChild?.cloneNode(true);
            blocksElement.textContent = (0, $07d93c758297752a$export$b1a1fb9a3c566543)(player.blocks);
            blocksElement.classList.toggle("homepage-lineup-table-item--sorted", this.sortKey === "blocks");
            cells[6].classList.toggle("homepage-lineup-table-sorted", this.sortKey === "blocks");
            cells[6].appendChild(blocksElement);
        });
        requestAnimationFrame(()=>{
            const firstNameCell = this.tableBody.children[0].querySelector("[role='cell']:not(:first-child)");
            firstNameCell.firstChild.addEventListener("transitionend", this.onTableRowsUpdateComplete, {
                once: true
            });
            this.tableBody.classList.add("homepage-lineup-table-body--updating");
            Array.from(this.tableBody.children).forEach((tableRow)=>{
                const nameCell = tableRow.querySelector("[role='cell']:not(:first-child)");
                const nameCellHeight = nameCell.children[1].getBoundingClientRect().height;
                const rowHeight = Math.max(nameCellHeight, nameCell.children[0].getBoundingClientRect().height);
                nameCell.style.setProperty("max-height", `${nameCellHeight}px`);
                nameCell.style.setProperty("grid-template-rows", `${rowHeight}px ${rowHeight}px`);
            });
        });
    }
    renderPlayerDashboard({ playerDashboard: playerDashboard, row: row, id: id, isRenderNext: isRenderNext, isPageLoad: isPageLoad }) {
        history.scrollRestoration = "manual";
        if (isRenderNext) {
            const hasHistoryModalState = history.state && history.state.modalId;
            history.replaceState({
                modalId: hasHistoryModalState ? id : undefined
            }, "", `#${id}`);
        } else {
            location.hash = `#${id}`;
            if (!isPageLoad) history.replaceState({
                modalId: id
            }, "", `#${id}`);
        }
        this.lineUpVideoContainerWrapperTranslateY -= this.lineUpVideoContainerWrapper.getBoundingClientRect().top;
        this.lineUpVideoContainerWrapper.style.setProperty("transform", `translateY(${this.lineUpVideoContainerWrapperTranslateY}px)`);
        // iOS Chrome occasionally renders dashboard below top 0 when the browser's URL bar is in compact mode
        const dashboardTop = playerDashboard.getBoundingClientRect().top;
        if (dashboardTop !== 0 && !isRenderNext) {
            this.activePlayerDashboardTranslateY -= dashboardTop;
            playerDashboard.style.setProperty("transform", `translateY(${this.activePlayerDashboardTranslateY}px)`);
        }
        this.activePlayerDashboardId = id;
        const currentPlayerIndex = this.sortedPlayers.indexOf(this.players.find((player)=>player.id === id));
        const rowCells = row.querySelectorAll("[role='cell']");
        const headers = Array.from(playerDashboard.querySelectorAll("[data-player-dashboard-header]"));
        // second to last header is header for current player
        // last header is header for next player
        headers.at(-2).classList.remove("player-dashboard__header--next-player");
        headers.at(-1).classList.add("player-dashboard__header--next-player");
        const headerNameEls = Array.from(headers).map((header)=>header.querySelector("[data-player-dashboard-header-name]"));
        if (!isRenderNext) headerNameEls.at(-2).innerHTML = rowCells[1].innerHTML;
        const nextPlayerIndex = (currentPlayerIndex + 1) % this.sortedPlayers.length;
        const nextPlayerTableRow = this.tableBody.children[nextPlayerIndex];
        const nextPlayerRowCells = nextPlayerTableRow.querySelectorAll("[role='cell']");
        headerNameEls.at(-1).innerHTML = nextPlayerRowCells[1].innerHTML;
        headerNameEls.at(-1).setAttribute("tabindex", "0");
        headerNameEls.at(-1).addEventListener("click", ()=>this.renderNextPlayerDashboard(playerDashboard, nextPlayerIndex), {
            once: true
        });
        let playerDashboardHeaderHeight = headers.at(-2).offsetHeight;
        this.pageMain.style.setProperty("--dashboard-video-title-top-offset", `${playerDashboardHeaderHeight}px`);
        this.playerDashboardHeaderResizeObserver = new ResizeObserver(()=>{
            if (playerDashboardHeaderHeight === headers.at(-2).offsetHeight) return;
            playerDashboardHeaderHeight = headers.at(-2).offsetHeight;
            this.lineUpVideoContainer.style.setProperty("transition", "none");
            this.pageMain.style.setProperty("--dashboard-video-title-top-offset", `${headers.at(-2).offsetHeight}px`);
            requestAnimationFrame(()=>{
                this.lineUpVideoContainer.style.removeProperty("transition");
            });
        });
        this.playerDashboardHeaderResizeObserver.observe(headers.at(-2));
        const playerDashboardContent = playerDashboard.querySelector("#player-dashboard-content");
        let playerDashboardBody;
        if (this.playerDashboardContentTemplateData[id]) {
            const playerDashboardGameTicket = this.playerDashboardContentTemplateData[id].content.cloneNode(true).children[0];
            playerDashboardBody = this.playerDashboardContentTemplateData[id].content.cloneNode(true).children[1];
            playerDashboardContent.insertBefore(playerDashboardBody, headers.at(-1));
            playerDashboardContent.insertBefore(playerDashboardGameTicket, playerDashboardBody);
            const ticketElement = playerDashboardGameTicket.children[0];
            if (ticketElement) {
                this.setTicketClipPath(playerDashboardGameTicket.children[0]);
                this.playerDashboardTicketResizeObserver = new ResizeObserver(()=>{
                    this.setTicketClipPath(playerDashboardGameTicket.children[0]);
                });
                this.playerDashboardTicketResizeObserver.observe(playerDashboardGameTicket);
            } else this.playerDashboardTicketResizeObserver?.disconnect();
        }
        if (!playerDashboardBody) {
            this.closePlayerDashboard();
            return;
        }
        const statsFilterButtons = Array.from(playerDashboardBody.querySelectorAll("#player-dashboard-stats-perf-filters button"));
        statsFilterButtons.forEach((button, index)=>{
            button.addEventListener("click", ()=>{
                button.classList.add("player-dashboard-player-stats-perf-button--active");
                statsFilterButtons.forEach((btn, btnIndex)=>{
                    if (btnIndex !== index) btn.classList.remove("player-dashboard-player-stats-perf-button--active");
                });
                const dataKey = $35a83204df8e8a21$var$SORT_KEYS[index];
                this.statsLineChart?.setDataKey(dataKey);
            });
        });
        const filterSelects = playerDashboardBody.querySelectorAll(".player-dashboard-player-stats-filter select");
        const getSelectedValues = ()=>{
            const values = {
                player: null,
                filters: {}
            };
            filterSelects.forEach((select)=>{
                const playerId = select.dataset.player || null;
                if (!values.player && playerId) values.player = playerId;
                values.filters[select.id] = select.value;
            });
            return values;
        };
        const handleChartResponse = (data)=>{
            console.log("Fetched data:", data);
            const [pointsButton, assistsButton, reboundsButton, stealsButton, blocksButton] = statsFilterButtons;
            const pointsAverage = this.getAverageFromLineChartData(data, "points");
            const assistsAverage = this.getAverageFromLineChartData(data, "assists");
            const reboundsAverage = this.getAverageFromLineChartData(data, "rebounds");
            const stealsAverage = this.getAverageFromLineChartData(data, "steals");
            const blocksAverage = this.getAverageFromLineChartData(data, "blocks");
            this.updateStatsFilterButtonValue(pointsButton, pointsAverage);
            this.updateStatsFilterButtonValue(assistsButton, assistsAverage);
            this.updateStatsFilterButtonValue(reboundsButton, reboundsAverage);
            this.updateStatsFilterButtonValue(stealsButton, stealsAverage);
            this.updateStatsFilterButtonValue(blocksButton, blocksAverage);
            this.statsLineChart?.setData(data);
        };
        filterSelects.forEach((select)=>{
            this.resizeSelectToFitContent(select);
            select.addEventListener("change", ()=>{
                const selectedValues = getSelectedValues();
                this.resizeSelectToFitContent(select);
                console.log("Selected values:", selectedValues);
                this.statsLineChart?.setData([]);
                fetch(`${location.origin}/wp-content/themes/nba-represent/_inc/hp-player-stats.php`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(selectedValues)
                }).then((res)=>{
                    if (!res.ok) throw new Error(`HTTP error! Status: ${res.status}`);
                    return res.json();
                }).then(handleChartResponse).catch((err)=>{
                    console.error("Fetch error:", err);
                // if (location.host === "localhost:1234") {
                //   setTimeout(() => {
                //     const [
                //       pointsButton,
                //       assistsButton,
                //       reboundsButton,
                //       stealsButton,
                //       blocksButton,
                //     ] = statsFilterButtons;
                //     const pointsAverage = this.getAverageFromLineChartData(
                //       LINE_CHART_DATA_TWO,
                //       "points"
                //     );
                //     const assistsAverage = this.getAverageFromLineChartData(
                //       LINE_CHART_DATA_TWO,
                //       "assists"
                //     );
                //     const reboundsAverage = this.getAverageFromLineChartData(
                //       LINE_CHART_DATA_TWO,
                //       "rebounds"
                //     );
                //     const stealsAverage = this.getAverageFromLineChartData(
                //       LINE_CHART_DATA_TWO,
                //       "steals"
                //     );
                //     const blocksAverage = this.getAverageFromLineChartData(
                //       LINE_CHART_DATA_TWO,
                //       "blocks"
                //     );
                //     this.updateStatsFilterButtonValue(pointsButton, pointsAverage);
                //     this.updateStatsFilterButtonValue(
                //       assistsButton,
                //       assistsAverage
                //     );
                //     this.updateStatsFilterButtonValue(
                //       reboundsButton,
                //       reboundsAverage
                //     );
                //     this.updateStatsFilterButtonValue(stealsButton, stealsAverage);
                //     this.updateStatsFilterButtonValue(blocksButton, blocksAverage);
                //     this.statsLineChart?.setData(LINE_CHART_DATA_TWO);
                //   }, 1000);
                // }
                });
            });
        });
        /*
    const statsPeriodSelect = playerDashboardBody.querySelector(
      `#stats-period-select-${id}`
    ) as HTMLSelectElement;

    statsPeriodSelect?.addEventListener("change", () => {
      const selectedValue = statsPeriodSelect.value;

      // for demo purposes only, should be replaced with actual player data
      const data =
        selectedValue === "2024-2025"
          ? LINE_CHART_DATA_TWO
          : LINE_CHART_DATA_ONE;

      const dataKeyIndex = statsFilterButtons.findIndex((button) =>
        button.classList.contains(
          "player-dashboard-player-stats-perf-button--active"
        )
      );

      this.statsLineChart?.destroy();

      this.statsLineChart = new StatsLineChart({
        container: statsLineChartContainer,
        data,
        dataKey: SORT_KEYS[dataKeyIndex] as StatsLineChartDataKey,
        dataKeyAbbreviation: this.dataKeyAbbreviation,
        onChartContainerScroll: this.onStatsChartContainerScroll,
      });
    });

       */ if (this.lenis) this.dashboardLenis = new (0, $8ecb29f509dc0bd0$export$2e2bcd8739ae039)({
            wrapper: playerDashboard,
            content: playerDashboardContent,
            autoRaf: true,
            prevent: ()=>this.preventDashboardLenisScroll && !this.forceDashboardLenisScroll
        });
        const statsLineChartContainer = playerDashboardBody.querySelector("[data-player-stats-chart]");
        this.statsLineChart?.destroy();
        if (statsLineChartContainer) {
            this.statsLineChart = new (0, $44475dd3aa49bf94$export$8af7671b8639436d)({
                container: statsLineChartContainer,
                data: [],
                dataKeyAbbreviation: this.dataKeyAbbreviation,
                onChartContainerScroll: this.onStatsChartContainerScroll
            });
            const handleChartResponseInitial = (data)=>{
                console.log("Fetched data:", data);
                this.statsLineChart?.setData(data);
            // this.statsLineChart = new StatsLineChart({
            //   container: statsLineChartContainer,
            //   // should be replaced with actual player data
            //   data,
            //   dataKeyAbbreviation: this.dataKeyAbbreviation,
            //   onChartContainerScroll: this.onStatsChartContainerScroll,
            // });
            };
            fetch(`${location.origin}/wp-content/themes/nba-represent/_inc/hp-player-stats-initial.php`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    playerId: this.activePlayerDashboardId
                })
            }).then((res)=>{
                if (!res.ok) throw new Error(`HTTP error! Status: ${res.status}`);
                return res.json();
            }).then(handleChartResponseInitial).catch((err)=>{
                console.error("Fetch error:", err);
            // if (location.host === "localhost:1234") {
            //   setTimeout(() => {
            //     this.statsLineChart?.setData(LINE_CHART_DATA_ONE);
            //   }, 0);
            // }
            });
        }
        requestAnimationFrame(()=>{
            playerDashboard.classList.add("player-dashboard--active");
        });
    }
}


class $ddf53db2d9e8628e$export$25b7c75712b6b29 {
    constructor(){
        this.updateActiveItem = (index)=>{
            this.items.forEach((item, itemIndex)=>{
                const itemFade = index >= 0 ? this.getItemFade(itemIndex, index) : {
                    opacity: 1,
                    blur: 0
                };
                item.style.setProperty("--fade-opacity", itemFade.opacity.toString());
                item.style.setProperty("--fade-blur", `${itemFade.blur}px`);
            });
        };
        this.getItemFade = (index, activeIndex)=>{
            if (index === activeIndex) return {
                opacity: 1,
                blur: 0
            };
            if (Math.abs(index - activeIndex) === 1) return {
                opacity: 0.4,
                blur: 1
            };
            if (Math.abs(index - activeIndex) === 2) return {
                opacity: 0.24,
                blur: 1.5
            };
            return {
                opacity: 0.12,
                blur: 2
            };
        };
        this.items = Array.from(document.querySelectorAll("#news-list li > a"));
        this.init();
    }
    init() {
        this.items.forEach((item, index)=>{
            item.addEventListener("pointerover", ()=>{
                this.updateActiveItem(index);
            });
            // add move for more stability when scrolling
            item.addEventListener("pointermove", ()=>{
                this.updateActiveItem(index);
            });
            item.addEventListener("focus", ()=>{
                this.updateActiveItem(index);
            });
            item.addEventListener("pointerleave", ()=>{
                this.updateActiveItem(-1);
            });
            item.addEventListener("blur", ()=>{
                this.updateActiveItem(-1);
            });
        });
    }
}




class $8bf3fff6b5f30aca$export$f8250c268cd0d487 {
    constructor(){
        this.prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        if (!this.prefersReducedMotion && !(0, $33b2d2d40c177c1d$export$d0a8044dce8ff2fc)()) this.lenis = new (0, $8ecb29f509dc0bd0$export$2e2bcd8739ae039)({
            autoRaf: true,
            anchors: true
        });
    }
}





const $b34a6e4a24ed7bbf$var$DESKTOP_ROW_CROSSHAIR_INDICES = [
    [
        0,
        1,
        5,
        6
    ],
    [
        1,
        2,
        6,
        7
    ],
    [
        2,
        3,
        7,
        8
    ],
    [
        3,
        4,
        8,
        9
    ]
];
const $b34a6e4a24ed7bbf$var$MOBILE_ROW_CROSSHAIR_INDICES = [
    [
        0,
        1,
        3,
        4
    ],
    [
        1,
        2,
        4,
        5
    ]
];
class $b34a6e4a24ed7bbf$export$cecc44f7b9e5ad9e {
    constructor(){
        this.prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        this.onDesktopImageMouseOver = (rowIndex, cellIndex)=>{
            const rowIndexOffset = rowIndex * 5;
            const topLeftIndex = $b34a6e4a24ed7bbf$var$DESKTOP_ROW_CROSSHAIR_INDICES[cellIndex][0] + rowIndexOffset;
            const topRightIndex = $b34a6e4a24ed7bbf$var$DESKTOP_ROW_CROSSHAIR_INDICES[cellIndex][1] + rowIndexOffset;
            const bottomLeftIndex = $b34a6e4a24ed7bbf$var$DESKTOP_ROW_CROSSHAIR_INDICES[cellIndex][2] + rowIndexOffset;
            const bottomRightIndex = $b34a6e4a24ed7bbf$var$DESKTOP_ROW_CROSSHAIR_INDICES[cellIndex][3] + rowIndexOffset;
            this.desktopCrosshairSVGs.forEach((svg, i)=>{
                switch(i){
                    case topLeftIndex:
                        svg.children[0].setAttribute("style", "transform: translate(-5px, 0px)");
                        svg.children[1].setAttribute("style", "transform: translate(0px, -5px)");
                        break;
                    case topRightIndex:
                        svg.children[0].setAttribute("style", "transform: translate(5px, 0px)");
                        svg.children[1].setAttribute("style", "transform: translate(0px, -5px)");
                        break;
                    case bottomLeftIndex:
                        svg.children[0].setAttribute("style", "transform: translate(-5px, 0px)");
                        svg.children[1].setAttribute("style", "transform: translate(0px, 5px)");
                        break;
                    case bottomRightIndex:
                        svg.children[0].setAttribute("style", "transform: translate(5px, 0px)");
                        svg.children[1].setAttribute("style", "transform: translate(0px, 5px)");
                        break;
                    default:
                        svg.children[0].setAttribute("style", "transform: translate(0px, 0px)");
                        svg.children[1].setAttribute("style", "transform: translate(0px, 0px)");
                        break;
                }
            });
        };
        this.onDesktopImageMouseOut = ()=>{
            this.desktopCrosshairSVGs.forEach((svg)=>{
                svg.children[0].setAttribute("style", "transform: translate(0px, 0px)");
                svg.children[1].setAttribute("style", "transform: translate(0px, 0px)");
            });
        };
        this.onMobileImageMouseOver = (rowIndex, cellIndex)=>{
            const rowIndexOffset = rowIndex * 3;
            const topLeftIndex = $b34a6e4a24ed7bbf$var$MOBILE_ROW_CROSSHAIR_INDICES[cellIndex][0] + rowIndexOffset;
            const topRightIndex = $b34a6e4a24ed7bbf$var$MOBILE_ROW_CROSSHAIR_INDICES[cellIndex][1] + rowIndexOffset;
            const bottomLeftIndex = $b34a6e4a24ed7bbf$var$MOBILE_ROW_CROSSHAIR_INDICES[cellIndex][2] + rowIndexOffset;
            const bottomRightIndex = $b34a6e4a24ed7bbf$var$MOBILE_ROW_CROSSHAIR_INDICES[cellIndex][3] + rowIndexOffset;
            this.mobileCrosshairSVGs.forEach((svg, i)=>{
                switch(i){
                    case topLeftIndex:
                        svg.children[0].setAttribute("style", "transform: translate(-5px, 0px)");
                        svg.children[1].setAttribute("style", "transform: translate(0px, -5px)");
                        break;
                    case topRightIndex:
                        svg.children[0].setAttribute("style", "transform: translate(5px, 0px)");
                        svg.children[1].setAttribute("style", "transform: translate(0px, -5px)");
                        break;
                    case bottomLeftIndex:
                        svg.children[0].setAttribute("style", "transform: translate(-5px, 0px)");
                        svg.children[1].setAttribute("style", "transform: translate(0px, 5px)");
                        break;
                    case bottomRightIndex:
                        svg.children[0].setAttribute("style", "transform: translate(5px, 0px)");
                        svg.children[1].setAttribute("style", "transform: translate(0px, 5px)");
                        break;
                    default:
                        svg.children[0].setAttribute("style", "transform: translate(0px, 0px)");
                        svg.children[1].setAttribute("style", "transform: translate(0px, 0px)");
                        break;
                }
            });
        };
        this.onMobileImageMouseOut = ()=>{
            this.mobileCrosshairSVGs.forEach((svg)=>{
                svg.children[0].setAttribute("style", "transform: translate(0px, 0px)");
                svg.children[1].setAttribute("style", "transform: translate(0px, 0px)");
            });
        };
        const socialSection = document.querySelector("#social-section");
        this.desktopRowElements = Array.from(socialSection.querySelectorAll("[data-social-images-desktop-row]"));
        this.mobileRowElements = Array.from(socialSection.querySelectorAll("[data-social-images-mobile-row]"));
        this.desktopCrosshairSVGs = Array.from(socialSection.querySelectorAll(".homepage-section-border--desktop svg"));
        this.mobileCrosshairSVGs = Array.from(socialSection.querySelectorAll(".homepage-section-border--mobile svg"));
        if (!this.prefersReducedMotion) this.init();
    }
    init() {
        this.desktopRowElements.forEach((row, rowIndex)=>{
            Array.from(row.children).forEach((cell, cellIndex)=>{
                cell.addEventListener("mouseover", ()=>this.onDesktopImageMouseOver(rowIndex, cellIndex));
                cell.addEventListener("mouseout", this.onDesktopImageMouseOut);
            });
        });
        this.mobileRowElements.forEach((row, rowIndex)=>{
            Array.from(row.children).forEach((cell, cellIndex)=>{
                cell.addEventListener("mouseover", ()=>this.onMobileImageMouseOver(rowIndex, cellIndex));
                cell.addEventListener("mouseout", this.onMobileImageMouseOut);
            });
        });
    }
}


class $f43313d21d3fd8e2$var$App {
    constructor(){
        this.isLocalDev = location.host === "localhost:1234";
        this.hasLoadedPage = false;
        this.onPageLoaderComplete = ()=>{
            if (this.hasLoadedPage) return;
            this.hasLoadedPage = true;
            this.mainContainer.style.removeProperty("opacity");
            document.body.querySelector("#homepage-hero-video").currentTime = 0;
        };
        this.smoothScroll = new (0, $8bf3fff6b5f30aca$export$f8250c268cd0d487)();
        this.mainContainer = document.querySelector("#homepage-main");
        this.init();
    }
    async init() {
        this.mainContainer.style.setProperty("opacity", "0");
        document.body.addEventListener("loader-25:completed", this.onPageLoaderComplete);
        const dataPath = this.isLocalDev ? "./data.json" : `${location.origin}/wp-content/themes/nba-represent/_inc/data.php`;
        const jsonData = await fetch(`${dataPath}?nocache=${Date.now()}`, {
            cache: "no-store"
        });
        const data = await jsonData.json();
        // Contest markup can be commented out of the homepage template, so only
        // boot the contest-related modules when their elements are present.
        if (document.querySelector("#hero-ticket")) new (0, $a665cea990d6196d$export$cc6082f938514827)(data.NEXT_CONTEST_TIMESTAMP);
        new (0, $35a83204df8e8a21$export$56b534bd20b9e350)({
            lenis: this.smoothScroll.lenis,
            players: data.PLAYERS,
            dataKeyAbbreviation: data.DATA_KEY_ABBREVIATION
        });
        if (document.querySelector("[data-basketball]")) new (0, $6ed61c8640a9c1ac$export$6dddbaab7b8f4743)();
        if (document.querySelector("[data-contest-tab-control-list]")) new (0, $5ce8c6471a69ea3e$export$10f66a48975af9bf)(data.CONTEST_TIMESTAMPS);
        if (document.querySelector("#contest-form")) new (0, $0736497199cfcb1e$export$7f3c5e03dd3ddc68)({
            lenis: this.smoothScroll.lenis
        });
        new (0, $b34a6e4a24ed7bbf$export$cecc44f7b9e5ad9e)();
        new (0, $ddf53db2d9e8628e$export$25b7c75712b6b29)();
        if (this.isLocalDev) {
            document.body.dispatchEvent(new CustomEvent("loader-25:completed"));
            document.body.dispatchEvent(new CustomEvent("loader-25:loader-exited"));
        }
    }
}
new $f43313d21d3fd8e2$var$App();


//# sourceMappingURL=homepage.ba9393af.js.map
